/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   font-metrics-data â€” baked advance-width tables for common spec fonts.

   GENERATED FILE â€” regenerate with:  node tools/extract-font-metrics.cjs
   (runs on a Windows machine with the fonts installed; extracts advance
   widths from the real font files via font-metrics.ts).

   This is DATA about fonts (glyph advance widths), not the fonts
   themselves â€” no font file ever ships to the server (platform law).
   Used when the engine runs where font files aren't available
   (EC2 web export) or the document names a font the machine lacks.
   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */

export interface BakedFace {
  /** font units per em */
  upem: number;
  /** fallback advance for unmapped characters (xAvgCharWidth) */
  avg: number;
  /** true when these numbers came from the real bold face */
  isBold: boolean;
  /** char code â†’ advance width in font units */
  adv: Record<number, number>;
}

export interface BakedFamily {
  regular?: BakedFace;
  bold?: BakedFace;
}

/** keys are lower-cased family names */
export const BAKED_FONT_METRICS: Record<string, BakedFamily> = {
  'century gothic': {
    regular: {
      upem: 2048,
      avg: 995,
      isBold: false,
      adv: {
        '32': 567,
        '33': 604,
        '34': 633,
        '35': 1475,
        '36': 1135,
        '37': 1587,
        '38': 1550,
        '39': 405,
        '40': 756,
        '41': 756,
        '42': 870,
        '43': 1241,
        '44': 567,
        '45': 680,
        '46': 567,
        '47': 895,
        '48': 1135,
        '49': 1135,
        '50': 1135,
        '51': 1135,
        '52': 1135,
        '53': 1135,
        '54': 1135,
        '55': 1135,
        '56': 1135,
        '57': 1135,
        '58': 567,
        '59': 567,
        '60': 1241,
        '61': 1241,
        '62': 1241,
        '63': 1210,
        '64': 1776,
        '65': 1515,
        '66': 1176,
        '67': 1665,
        '68': 1524,
        '69': 1098,
        '70': 993,
        '71': 1786,
        '72': 1399,
        '73': 463,
        '74': 987,
        '75': 1210,
        '76': 946,
        '77': 1882,
        '78': 1515,
        '79': 1780,
        '80': 1212,
        '81': 1784,
        '82': 1243,
        '83': 1020,
        '84': 872,
        '85': 1341,
        '86': 1438,
        '87': 1966,
        '88': 1247,
        '89': 1212,
        '90': 983,
        '91': 719,
        '92': 1239,
        '93': 719,
        '94': 1376,
        '95': 1024,
        '96': 774,
        '97': 1399,
        '98': 1397,
        '99': 1325,
        '100': 1403,
        '101': 1331,
        '102': 643,
        '103': 1378,
        '104': 1249,
        '105': 410,
        '106': 416,
        '107': 1028,
        '108': 410,
        '109': 1921,
        '110': 1249,
        '111': 1341,
        '112': 1397,
        '113': 1397,
        '114': 616,
        '115': 795,
        '116': 694,
        '117': 1245,
        '118': 1135,
        '119': 1702,
        '120': 983,
        '121': 1098,
        '122': 870,
        '123': 719,
        '124': 1376,
        '125': 719,
        '126': 1241,
        '160': 573,
        '161': 604,
        '162': 1135,
        '163': 1135,
        '164': 1135,
        '165': 1135,
        '166': 1376,
        '167': 1259,
        '168': 756,
        '169': 1530,
        '170': 756,
        '171': 870,
        '172': 1241,
        '173': 680,
        '174': 1530,
        '175': 1024,
        '176': 819,
        '177': 1124,
        '178': 680,
        '179': 705,
        '180': 768,
        '181': 1180,
        '182': 1155,
        '183': 682,
        '184': 664,
        '185': 680,
        '186': 756,
        '187': 870,
        '188': 1702,
        '189': 1702,
        '190': 1702,
        '191': 1210,
        '192': 1515,
        '193': 1515,
        '194': 1515,
        '195': 1515,
        '196': 1515,
        '197': 1515,
        '198': 2032,
        '199': 1665,
        '200': 1098,
        '201': 1098,
        '202': 1098,
        '203': 1098,
        '204': 463,
        '205': 463,
        '206': 463,
        '207': 463,
        '208': 1618,
        '209': 1515,
        '210': 1780,
        '211': 1780,
        '212': 1780,
        '213': 1780,
        '214': 1780,
        '215': 1241,
        '216': 1778,
        '217': 1341,
        '218': 1341,
        '219': 1341,
        '220': 1341,
        '221': 1212,
        '222': 1212,
        '223': 1135,
        '224': 1399,
        '225': 1399,
        '226': 1399,
        '227': 1399,
        '228': 1399,
        '229': 1399,
        '230': 2370,
        '231': 1325,
        '232': 1331,
        '233': 1331,
        '234': 1331,
        '235': 1331,
        '236': 410,
        '237': 410,
        '238': 410,
        '239': 410,
        '240': 1341,
        '241': 1249,
        '242': 1341,
        '243': 1341,
        '244': 1341,
        '245': 1341,
        '246': 1341,
        '247': 1124,
        '248': 1337,
        '249': 1245,
        '250': 1245,
        '251': 1245,
        '252': 1245,
        '253': 1098,
        '254': 1397,
        '255': 1098,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8215': 1024,
        '8216': 719,
        '8217': 719,
        '8218': 725,
        '8219': 719,
        '8220': 1028,
        '8221': 991,
        '8222': 1028,
        '8224': 1133,
        '8225': 1133,
        '8226': 1241,
        '8230': 2048,
        '8482': 2048,
      },
    },
    bold: {
      upem: 2048,
      avg: 994,
      isBold: true,
      adv: {
        '32': 573,
        '33': 573,
        '34': 737,
        '35': 1229,
        '36': 1147,
        '37': 1761,
        '38': 1393,
        '39': 451,
        '40': 778,
        '41': 778,
        '42': 901,
        '43': 1229,
        '44': 573,
        '45': 860,
        '46': 573,
        '47': 942,
        '48': 1147,
        '49': 1147,
        '50': 1147,
        '51': 1147,
        '52': 1147,
        '53': 1147,
        '54': 1147,
        '55': 1147,
        '56': 1147,
        '57': 1147,
        '58': 573,
        '59': 573,
        '60': 1229,
        '61': 1229,
        '62': 1229,
        '63': 1147,
        '64': 1515,
        '65': 1515,
        '66': 1188,
        '67': 1597,
        '68': 1434,
        '69': 1065,
        '70': 983,
        '71': 1720,
        '72': 1393,
        '73': 573,
        '74': 983,
        '75': 1270,
        '76': 901,
        '77': 1843,
        '78': 1515,
        '79': 1720,
        '80': 1147,
        '81': 1720,
        '82': 1188,
        '83': 1065,
        '84': 860,
        '85': 1311,
        '86': 1434,
        '87': 1843,
        '88': 1393,
        '89': 1270,
        '90': 1024,
        '91': 655,
        '92': 1311,
        '93': 655,
        '94': 1229,
        '95': 1024,
        '96': 860,
        '97': 1352,
        '98': 1352,
        '99': 1311,
        '100': 1352,
        '101': 1311,
        '102': 573,
        '103': 1352,
        '104': 1229,
        '105': 491,
        '106': 532,
        '107': 1188,
        '108': 491,
        '109': 1925,
        '110': 1229,
        '111': 1311,
        '112': 1352,
        '113': 1352,
        '114': 655,
        '115': 901,
        '116': 614,
        '117': 1229,
        '118': 1147,
        '119': 1638,
        '120': 1147,
        '121': 1188,
        '122': 942,
        '123': 696,
        '124': 1229,
        '125': 696,
        '126': 1229,
        '160': 573,
        '161': 573,
        '162': 1147,
        '163': 1147,
        '164': 1229,
        '165': 1147,
        '166': 1229,
        '167': 1147,
        '168': 1024,
        '169': 1515,
        '170': 737,
        '171': 942,
        '172': 1229,
        '173': 860,
        '174': 1515,
        '175': 1024,
        '176': 819,
        '177': 1124,
        '178': 688,
        '179': 688,
        '180': 860,
        '181': 1180,
        '182': 1229,
        '183': 682,
        '184': 696,
        '185': 688,
        '186': 737,
        '187': 942,
        '188': 1720,
        '189': 1720,
        '190': 1720,
        '191': 1147,
        '192': 1515,
        '193': 1515,
        '194': 1515,
        '195': 1515,
        '196': 1515,
        '197': 1515,
        '198': 1843,
        '199': 1597,
        '200': 1065,
        '201': 1065,
        '202': 1065,
        '203': 1065,
        '204': 573,
        '205': 573,
        '206': 573,
        '207': 573,
        '208': 1520,
        '209': 1515,
        '210': 1720,
        '211': 1720,
        '212': 1720,
        '213': 1720,
        '214': 1720,
        '215': 1229,
        '216': 1720,
        '217': 1311,
        '218': 1311,
        '219': 1311,
        '220': 1311,
        '221': 1270,
        '222': 1147,
        '223': 1229,
        '224': 1352,
        '225': 1352,
        '226': 1352,
        '227': 1352,
        '228': 1352,
        '229': 1352,
        '230': 2212,
        '231': 1311,
        '232': 1311,
        '233': 1311,
        '234': 1311,
        '235': 1311,
        '236': 491,
        '237': 491,
        '238': 491,
        '239': 491,
        '240': 1311,
        '241': 1229,
        '242': 1311,
        '243': 1311,
        '244': 1311,
        '245': 1311,
        '246': 1311,
        '247': 1124,
        '248': 1352,
        '249': 1229,
        '250': 1229,
        '251': 1229,
        '252': 1229,
        '253': 1188,
        '254': 1352,
        '255': 1188,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8215': 1024,
        '8216': 573,
        '8217': 573,
        '8218': 573,
        '8219': 573,
        '8220': 983,
        '8221': 983,
        '8222': 983,
        '8224': 1147,
        '8225': 1147,
        '8226': 1229,
        '8230': 2048,
        '8482': 2048,
      },
    },
  },
  arial: {
    regular: {
      upem: 2048,
      avg: 904,
      isBold: false,
      adv: {
        '32': 569,
        '33': 569,
        '34': 727,
        '35': 1139,
        '36': 1139,
        '37': 1821,
        '38': 1366,
        '39': 391,
        '40': 682,
        '41': 682,
        '42': 797,
        '43': 1196,
        '44': 569,
        '45': 682,
        '46': 569,
        '47': 569,
        '48': 1139,
        '49': 1139,
        '50': 1139,
        '51': 1139,
        '52': 1139,
        '53': 1139,
        '54': 1139,
        '55': 1139,
        '56': 1139,
        '57': 1139,
        '58': 569,
        '59': 569,
        '60': 1196,
        '61': 1196,
        '62': 1196,
        '63': 1139,
        '64': 2079,
        '65': 1366,
        '66': 1366,
        '67': 1479,
        '68': 1479,
        '69': 1366,
        '70': 1251,
        '71': 1593,
        '72': 1479,
        '73': 569,
        '74': 1024,
        '75': 1366,
        '76': 1139,
        '77': 1706,
        '78': 1479,
        '79': 1593,
        '80': 1366,
        '81': 1593,
        '82': 1479,
        '83': 1366,
        '84': 1251,
        '85': 1479,
        '86': 1366,
        '87': 1933,
        '88': 1366,
        '89': 1366,
        '90': 1251,
        '91': 569,
        '92': 569,
        '93': 569,
        '94': 961,
        '95': 1139,
        '96': 682,
        '97': 1139,
        '98': 1139,
        '99': 1024,
        '100': 1139,
        '101': 1139,
        '102': 569,
        '103': 1139,
        '104': 1139,
        '105': 455,
        '106': 455,
        '107': 1024,
        '108': 455,
        '109': 1706,
        '110': 1139,
        '111': 1139,
        '112': 1139,
        '113': 1139,
        '114': 682,
        '115': 1024,
        '116': 569,
        '117': 1139,
        '118': 1024,
        '119': 1479,
        '120': 1024,
        '121': 1024,
        '122': 1024,
        '123': 684,
        '124': 532,
        '125': 684,
        '126': 1196,
        '160': 569,
        '161': 682,
        '162': 1139,
        '163': 1139,
        '164': 1139,
        '165': 1139,
        '166': 532,
        '167': 1139,
        '168': 682,
        '169': 1509,
        '170': 758,
        '171': 1139,
        '172': 1196,
        '173': 682,
        '174': 1509,
        '175': 1131,
        '176': 819,
        '177': 1124,
        '178': 682,
        '179': 682,
        '180': 682,
        '181': 1180,
        '182': 1100,
        '183': 682,
        '184': 682,
        '185': 682,
        '186': 748,
        '187': 1139,
        '188': 1708,
        '189': 1708,
        '190': 1708,
        '191': 1251,
        '192': 1366,
        '193': 1366,
        '194': 1366,
        '195': 1366,
        '196': 1366,
        '197': 1366,
        '198': 2048,
        '199': 1479,
        '200': 1366,
        '201': 1366,
        '202': 1366,
        '203': 1366,
        '204': 569,
        '205': 569,
        '206': 569,
        '207': 569,
        '208': 1479,
        '209': 1479,
        '210': 1593,
        '211': 1593,
        '212': 1593,
        '213': 1593,
        '214': 1593,
        '215': 1196,
        '216': 1593,
        '217': 1479,
        '218': 1479,
        '219': 1479,
        '220': 1479,
        '221': 1366,
        '222': 1366,
        '223': 1251,
        '224': 1139,
        '225': 1139,
        '226': 1139,
        '227': 1139,
        '228': 1139,
        '229': 1139,
        '230': 1821,
        '231': 1024,
        '232': 1139,
        '233': 1139,
        '234': 1139,
        '235': 1139,
        '236': 569,
        '237': 569,
        '238': 569,
        '239': 569,
        '240': 1139,
        '241': 1139,
        '242': 1139,
        '243': 1139,
        '244': 1139,
        '245': 1139,
        '246': 1139,
        '247': 1124,
        '248': 1251,
        '249': 1139,
        '250': 1139,
        '251': 1139,
        '252': 1139,
        '253': 1024,
        '254': 1139,
        '255': 1024,
        '8210': 1139,
        '8211': 1139,
        '8212': 2048,
        '8213': 2048,
        '8214': 846,
        '8215': 1131,
        '8216': 455,
        '8217': 455,
        '8218': 455,
        '8219': 455,
        '8220': 682,
        '8221': 682,
        '8222': 682,
        '8223': 682,
        '8224': 1139,
        '8225': 1139,
        '8226': 717,
        '8230': 2048,
        '8482': 2048,
      },
    },
    bold: {
      upem: 2048,
      avg: 980,
      isBold: true,
      adv: {
        '32': 569,
        '33': 682,
        '34': 971,
        '35': 1139,
        '36': 1139,
        '37': 1821,
        '38': 1479,
        '39': 487,
        '40': 682,
        '41': 682,
        '42': 797,
        '43': 1196,
        '44': 569,
        '45': 682,
        '46': 569,
        '47': 569,
        '48': 1139,
        '49': 1139,
        '50': 1139,
        '51': 1139,
        '52': 1139,
        '53': 1139,
        '54': 1139,
        '55': 1139,
        '56': 1139,
        '57': 1139,
        '58': 682,
        '59': 682,
        '60': 1196,
        '61': 1196,
        '62': 1196,
        '63': 1251,
        '64': 1997,
        '65': 1479,
        '66': 1479,
        '67': 1479,
        '68': 1479,
        '69': 1366,
        '70': 1251,
        '71': 1593,
        '72': 1479,
        '73': 569,
        '74': 1139,
        '75': 1479,
        '76': 1251,
        '77': 1706,
        '78': 1479,
        '79': 1593,
        '80': 1366,
        '81': 1593,
        '82': 1479,
        '83': 1366,
        '84': 1251,
        '85': 1479,
        '86': 1366,
        '87': 1933,
        '88': 1366,
        '89': 1366,
        '90': 1251,
        '91': 682,
        '92': 569,
        '93': 682,
        '94': 1196,
        '95': 1139,
        '96': 682,
        '97': 1139,
        '98': 1251,
        '99': 1139,
        '100': 1251,
        '101': 1139,
        '102': 682,
        '103': 1251,
        '104': 1251,
        '105': 569,
        '106': 569,
        '107': 1139,
        '108': 569,
        '109': 1821,
        '110': 1251,
        '111': 1251,
        '112': 1251,
        '113': 1251,
        '114': 797,
        '115': 1139,
        '116': 682,
        '117': 1251,
        '118': 1139,
        '119': 1593,
        '120': 1139,
        '121': 1139,
        '122': 1024,
        '123': 797,
        '124': 573,
        '125': 797,
        '126': 1196,
        '160': 569,
        '161': 682,
        '162': 1139,
        '163': 1139,
        '164': 1139,
        '165': 1139,
        '166': 573,
        '167': 1139,
        '168': 682,
        '169': 1509,
        '170': 758,
        '171': 1139,
        '172': 1196,
        '173': 682,
        '174': 1509,
        '175': 1131,
        '176': 819,
        '177': 1124,
        '178': 682,
        '179': 682,
        '180': 682,
        '181': 1180,
        '182': 1139,
        '183': 682,
        '184': 682,
        '185': 682,
        '186': 748,
        '187': 1139,
        '188': 1708,
        '189': 1708,
        '190': 1708,
        '191': 1251,
        '192': 1479,
        '193': 1479,
        '194': 1479,
        '195': 1479,
        '196': 1479,
        '197': 1479,
        '198': 2048,
        '199': 1479,
        '200': 1366,
        '201': 1366,
        '202': 1366,
        '203': 1366,
        '204': 569,
        '205': 569,
        '206': 569,
        '207': 569,
        '208': 1479,
        '209': 1479,
        '210': 1593,
        '211': 1593,
        '212': 1593,
        '213': 1593,
        '214': 1593,
        '215': 1196,
        '216': 1593,
        '217': 1479,
        '218': 1479,
        '219': 1479,
        '220': 1479,
        '221': 1366,
        '222': 1366,
        '223': 1251,
        '224': 1139,
        '225': 1139,
        '226': 1139,
        '227': 1139,
        '228': 1139,
        '229': 1139,
        '230': 1821,
        '231': 1139,
        '232': 1139,
        '233': 1139,
        '234': 1139,
        '235': 1139,
        '236': 569,
        '237': 569,
        '238': 569,
        '239': 569,
        '240': 1251,
        '241': 1251,
        '242': 1251,
        '243': 1251,
        '244': 1251,
        '245': 1251,
        '246': 1251,
        '247': 1124,
        '248': 1251,
        '249': 1251,
        '250': 1251,
        '251': 1251,
        '252': 1251,
        '253': 1139,
        '254': 1251,
        '255': 1139,
        '8210': 1139,
        '8211': 1139,
        '8212': 2048,
        '8213': 2048,
        '8214': 1019,
        '8215': 1131,
        '8216': 569,
        '8217': 569,
        '8218': 569,
        '8219': 569,
        '8220': 1024,
        '8221': 1024,
        '8222': 1024,
        '8223': 1024,
        '8224': 1139,
        '8225': 1139,
        '8226': 717,
        '8230': 2048,
        '8482': 2048,
      },
    },
  },
  'times new roman': {
    regular: {
      upem: 2048,
      avg: 821,
      isBold: false,
      adv: {
        '32': 512,
        '33': 682,
        '34': 836,
        '35': 1024,
        '36': 1024,
        '37': 1706,
        '38': 1593,
        '39': 369,
        '40': 682,
        '41': 682,
        '42': 1024,
        '43': 1155,
        '44': 512,
        '45': 682,
        '46': 512,
        '47': 569,
        '48': 1024,
        '49': 1024,
        '50': 1024,
        '51': 1024,
        '52': 1024,
        '53': 1024,
        '54': 1024,
        '55': 1024,
        '56': 1024,
        '57': 1024,
        '58': 569,
        '59': 569,
        '60': 1155,
        '61': 1155,
        '62': 1155,
        '63': 909,
        '64': 1886,
        '65': 1479,
        '66': 1366,
        '67': 1366,
        '68': 1479,
        '69': 1251,
        '70': 1139,
        '71': 1479,
        '72': 1479,
        '73': 682,
        '74': 797,
        '75': 1479,
        '76': 1251,
        '77': 1821,
        '78': 1479,
        '79': 1479,
        '80': 1139,
        '81': 1479,
        '82': 1366,
        '83': 1139,
        '84': 1251,
        '85': 1479,
        '86': 1479,
        '87': 1933,
        '88': 1479,
        '89': 1479,
        '90': 1251,
        '91': 682,
        '92': 569,
        '93': 682,
        '94': 961,
        '95': 1024,
        '96': 682,
        '97': 909,
        '98': 1024,
        '99': 909,
        '100': 1024,
        '101': 909,
        '102': 682,
        '103': 1024,
        '104': 1024,
        '105': 569,
        '106': 569,
        '107': 1024,
        '108': 569,
        '109': 1593,
        '110': 1024,
        '111': 1024,
        '112': 1024,
        '113': 1024,
        '114': 682,
        '115': 797,
        '116': 569,
        '117': 1024,
        '118': 1024,
        '119': 1479,
        '120': 1024,
        '121': 1024,
        '122': 909,
        '123': 983,
        '124': 410,
        '125': 983,
        '126': 1108,
        '160': 512,
        '161': 682,
        '162': 1024,
        '163': 1024,
        '164': 1024,
        '165': 1024,
        '166': 410,
        '167': 1024,
        '168': 682,
        '169': 1556,
        '170': 565,
        '171': 1024,
        '172': 1155,
        '173': 682,
        '174': 1556,
        '175': 1024,
        '176': 819,
        '177': 1124,
        '178': 614,
        '179': 614,
        '180': 682,
        '181': 1180,
        '182': 928,
        '183': 682,
        '184': 682,
        '185': 614,
        '186': 635,
        '187': 1024,
        '188': 1536,
        '189': 1536,
        '190': 1536,
        '191': 909,
        '192': 1479,
        '193': 1479,
        '194': 1479,
        '195': 1479,
        '196': 1479,
        '197': 1479,
        '198': 1821,
        '199': 1366,
        '200': 1251,
        '201': 1251,
        '202': 1251,
        '203': 1251,
        '204': 682,
        '205': 682,
        '206': 682,
        '207': 682,
        '208': 1479,
        '209': 1479,
        '210': 1479,
        '211': 1479,
        '212': 1479,
        '213': 1479,
        '214': 1479,
        '215': 1155,
        '216': 1479,
        '217': 1479,
        '218': 1479,
        '219': 1479,
        '220': 1479,
        '221': 1479,
        '222': 1139,
        '223': 1024,
        '224': 909,
        '225': 909,
        '226': 909,
        '227': 909,
        '228': 909,
        '229': 909,
        '230': 1366,
        '231': 909,
        '232': 909,
        '233': 909,
        '234': 909,
        '235': 909,
        '236': 569,
        '237': 569,
        '238': 569,
        '239': 569,
        '240': 1024,
        '241': 1024,
        '242': 1024,
        '243': 1024,
        '244': 1024,
        '245': 1024,
        '246': 1024,
        '247': 1124,
        '248': 1024,
        '249': 1024,
        '250': 1024,
        '251': 1024,
        '252': 1024,
        '253': 1024,
        '254': 1024,
        '255': 1024,
        '8208': 682,
        '8209': 682,
        '8210': 1024,
        '8211': 1024,
        '8212': 2048,
        '8213': 2048,
        '8214': 575,
        '8215': 1024,
        '8216': 682,
        '8217': 682,
        '8218': 682,
        '8219': 682,
        '8220': 909,
        '8221': 909,
        '8222': 909,
        '8223': 909,
        '8224': 1024,
        '8225': 1024,
        '8226': 717,
        '8227': 717,
        '8228': 682,
        '8229': 1364,
        '8230': 2048,
        '8482': 2007,
      },
    },
    bold: {
      upem: 2048,
      avg: 874,
      isBold: true,
      adv: {
        '32': 512,
        '33': 682,
        '34': 1137,
        '35': 1024,
        '36': 1024,
        '37': 2048,
        '38': 1706,
        '39': 569,
        '40': 682,
        '41': 682,
        '42': 1024,
        '43': 1167,
        '44': 512,
        '45': 682,
        '46': 512,
        '47': 569,
        '48': 1024,
        '49': 1024,
        '50': 1024,
        '51': 1024,
        '52': 1024,
        '53': 1024,
        '54': 1024,
        '55': 1024,
        '56': 1024,
        '57': 1024,
        '58': 682,
        '59': 682,
        '60': 1167,
        '61': 1167,
        '62': 1167,
        '63': 1024,
        '64': 1905,
        '65': 1479,
        '66': 1366,
        '67': 1479,
        '68': 1479,
        '69': 1366,
        '70': 1251,
        '71': 1593,
        '72': 1593,
        '73': 797,
        '74': 1024,
        '75': 1593,
        '76': 1366,
        '77': 1933,
        '78': 1479,
        '79': 1593,
        '80': 1251,
        '81': 1593,
        '82': 1479,
        '83': 1139,
        '84': 1366,
        '85': 1479,
        '86': 1479,
        '87': 2048,
        '88': 1479,
        '89': 1479,
        '90': 1366,
        '91': 682,
        '92': 569,
        '93': 682,
        '94': 1190,
        '95': 1024,
        '96': 682,
        '97': 1024,
        '98': 1139,
        '99': 909,
        '100': 1139,
        '101': 909,
        '102': 682,
        '103': 1024,
        '104': 1139,
        '105': 569,
        '106': 682,
        '107': 1139,
        '108': 569,
        '109': 1706,
        '110': 1139,
        '111': 1024,
        '112': 1139,
        '113': 1139,
        '114': 909,
        '115': 797,
        '116': 682,
        '117': 1139,
        '118': 1024,
        '119': 1479,
        '120': 1024,
        '121': 1024,
        '122': 909,
        '123': 807,
        '124': 451,
        '125': 807,
        '126': 1065,
        '160': 512,
        '161': 682,
        '162': 1024,
        '163': 1024,
        '164': 1024,
        '165': 1024,
        '166': 451,
        '167': 1024,
        '168': 682,
        '169': 1530,
        '170': 614,
        '171': 1024,
        '172': 1167,
        '173': 682,
        '174': 1530,
        '175': 1024,
        '176': 819,
        '177': 1124,
        '178': 614,
        '179': 614,
        '180': 682,
        '181': 1180,
        '182': 1106,
        '183': 683,
        '184': 682,
        '185': 614,
        '186': 676,
        '187': 1024,
        '188': 1536,
        '189': 1536,
        '190': 1536,
        '191': 1024,
        '192': 1479,
        '193': 1479,
        '194': 1479,
        '195': 1479,
        '196': 1479,
        '197': 1479,
        '198': 2048,
        '199': 1479,
        '200': 1366,
        '201': 1366,
        '202': 1366,
        '203': 1366,
        '204': 797,
        '205': 797,
        '206': 797,
        '207': 797,
        '208': 1479,
        '209': 1479,
        '210': 1593,
        '211': 1593,
        '212': 1593,
        '213': 1593,
        '214': 1593,
        '215': 1167,
        '216': 1593,
        '217': 1479,
        '218': 1479,
        '219': 1479,
        '220': 1479,
        '221': 1479,
        '222': 1251,
        '223': 1139,
        '224': 1024,
        '225': 1024,
        '226': 1024,
        '227': 1024,
        '228': 1024,
        '229': 1024,
        '230': 1479,
        '231': 909,
        '232': 909,
        '233': 909,
        '234': 909,
        '235': 909,
        '236': 569,
        '237': 569,
        '238': 569,
        '239': 569,
        '240': 1024,
        '241': 1139,
        '242': 1024,
        '243': 1024,
        '244': 1024,
        '245': 1024,
        '246': 1024,
        '247': 1124,
        '248': 1024,
        '249': 1139,
        '250': 1139,
        '251': 1139,
        '252': 1139,
        '253': 1024,
        '254': 1139,
        '255': 1024,
        '8208': 682,
        '8209': 682,
        '8210': 1024,
        '8211': 1024,
        '8212': 2048,
        '8213': 2048,
        '8214': 664,
        '8215': 1024,
        '8216': 682,
        '8217': 682,
        '8218': 682,
        '8219': 682,
        '8220': 1024,
        '8221': 1024,
        '8222': 1024,
        '8223': 1024,
        '8224': 1024,
        '8225': 1024,
        '8226': 717,
        '8227': 717,
        '8228': 683,
        '8229': 1365,
        '8230': 2048,
        '8482': 2048,
      },
    },
  },
  calibri: {
    regular: {
      upem: 2048,
      avg: 1067,
      isBold: false,
      adv: {
        '32': 463,
        '33': 667,
        '34': 821,
        '35': 1020,
        '36': 1038,
        '37': 1464,
        '38': 1397,
        '39': 452,
        '40': 621,
        '41': 621,
        '42': 1020,
        '43': 1020,
        '44': 511,
        '45': 627,
        '46': 517,
        '47': 791,
        '48': 1038,
        '49': 1038,
        '50': 1038,
        '51': 1038,
        '52': 1038,
        '53': 1038,
        '54': 1038,
        '55': 1038,
        '56': 1038,
        '57': 1038,
        '58': 548,
        '59': 548,
        '60': 1020,
        '61': 1020,
        '62': 1020,
        '63': 949,
        '64': 1831,
        '65': 1185,
        '66': 1114,
        '67': 1092,
        '68': 1260,
        '69': 1000,
        '70': 941,
        '71': 1292,
        '72': 1276,
        '73': 516,
        '74': 653,
        '75': 1064,
        '76': 861,
        '77': 1751,
        '78': 1322,
        '79': 1356,
        '80': 1058,
        '81': 1378,
        '82': 1112,
        '83': 941,
        '84': 998,
        '85': 1314,
        '86': 1162,
        '87': 1822,
        '88': 1063,
        '89': 998,
        '90': 959,
        '91': 628,
        '92': 791,
        '93': 628,
        '94': 1020,
        '95': 1020,
        '96': 596,
        '97': 981,
        '98': 1076,
        '99': 866,
        '100': 1076,
        '101': 1019,
        '102': 625,
        '103': 964,
        '104': 1076,
        '105': 470,
        '106': 490,
        '107': 931,
        '108': 470,
        '109': 1636,
        '110': 1076,
        '111': 1080,
        '112': 1076,
        '113': 1076,
        '114': 714,
        '115': 801,
        '116': 686,
        '117': 1076,
        '118': 925,
        '119': 1464,
        '120': 887,
        '121': 927,
        '122': 809,
        '123': 644,
        '124': 943,
        '125': 644,
        '126': 1020,
        '160': 463,
        '161': 667,
        '162': 1020,
        '163': 1038,
        '164': 1020,
        '165': 1038,
        '166': 1020,
        '167': 1020,
        '168': 804,
        '169': 1709,
        '170': 824,
        '171': 1049,
        '172': 1020,
        '173': 627,
        '174': 1038,
        '175': 807,
        '176': 694,
        '177': 1020,
        '178': 688,
        '179': 685,
        '180': 598,
        '181': 1126,
        '182': 1200,
        '183': 517,
        '184': 629,
        '185': 504,
        '186': 865,
        '187': 1049,
        '188': 1303,
        '189': 1375,
        '190': 1383,
        '191': 949,
        '192': 1185,
        '193': 1185,
        '194': 1185,
        '195': 1185,
        '196': 1185,
        '197': 1185,
        '198': 1563,
        '199': 1092,
        '200': 1000,
        '201': 1000,
        '202': 1000,
        '203': 1000,
        '204': 516,
        '205': 516,
        '206': 516,
        '207': 516,
        '208': 1279,
        '209': 1322,
        '210': 1356,
        '211': 1356,
        '212': 1356,
        '213': 1356,
        '214': 1356,
        '215': 1020,
        '216': 1359,
        '217': 1314,
        '218': 1314,
        '219': 1314,
        '220': 1314,
        '221': 998,
        '222': 1058,
        '223': 1080,
        '224': 981,
        '225': 981,
        '226': 981,
        '227': 981,
        '228': 981,
        '229': 981,
        '230': 1583,
        '231': 866,
        '232': 1019,
        '233': 1019,
        '234': 1019,
        '235': 1019,
        '236': 470,
        '237': 470,
        '238': 470,
        '239': 470,
        '240': 1076,
        '241': 1076,
        '242': 1080,
        '243': 1080,
        '244': 1080,
        '245': 1080,
        '246': 1080,
        '247': 1020,
        '248': 1084,
        '249': 1076,
        '250': 1076,
        '251': 1076,
        '252': 1076,
        '253': 927,
        '254': 1076,
        '255': 927,
        '8208': 627,
        '8210': 1038,
        '8211': 1020,
        '8212': 1854,
        '8213': 1854,
        '8214': 809,
        '8215': 1020,
        '8216': 511,
        '8217': 511,
        '8218': 511,
        '8219': 511,
        '8220': 857,
        '8221': 857,
        '8222': 857,
        '8223': 856,
        '8224': 1020,
        '8225': 1020,
        '8226': 1020,
        '8228': 517,
        '8230': 1414,
        '8482': 1444,
      },
    },
    bold: {
      upem: 2048,
      avg: 1098,
      isBold: true,
      adv: {
        '32': 463,
        '33': 667,
        '34': 898,
        '35': 1020,
        '36': 1038,
        '37': 1493,
        '38': 1443,
        '39': 478,
        '40': 638,
        '41': 638,
        '42': 1020,
        '43': 1020,
        '44': 528,
        '45': 627,
        '46': 547,
        '47': 880,
        '48': 1038,
        '49': 1038,
        '50': 1038,
        '51': 1038,
        '52': 1038,
        '53': 1038,
        '54': 1038,
        '55': 1038,
        '56': 1038,
        '57': 1038,
        '58': 565,
        '59': 565,
        '60': 1020,
        '61': 1020,
        '62': 1020,
        '63': 949,
        '64': 1840,
        '65': 1241,
        '66': 1148,
        '67': 1084,
        '68': 1291,
        '69': 999,
        '70': 940,
        '71': 1305,
        '72': 1292,
        '73': 546,
        '74': 678,
        '75': 1120,
        '76': 866,
        '77': 1790,
        '78': 1349,
        '79': 1385,
        '80': 1090,
        '81': 1405,
        '82': 1153,
        '83': 968,
        '84': 1014,
        '85': 1337,
        '86': 1211,
        '87': 1856,
        '88': 1128,
        '89': 1064,
        '90': 979,
        '91': 665,
        '92': 880,
        '93': 665,
        '94': 1020,
        '95': 1020,
        '96': 615,
        '97': 1011,
        '98': 1099,
        '99': 857,
        '100': 1099,
        '101': 1031,
        '102': 648,
        '103': 971,
        '104': 1099,
        '105': 503,
        '106': 523,
        '107': 983,
        '108': 503,
        '109': 1666,
        '110': 1099,
        '111': 1101,
        '112': 1099,
        '113': 1099,
        '114': 728,
        '115': 817,
        '116': 710,
        '117': 1099,
        '118': 969,
        '119': 1526,
        '120': 941,
        '121': 970,
        '122': 814,
        '123': 704,
        '124': 973,
        '125': 704,
        '126': 1020,
        '160': 463,
        '161': 667,
        '162': 1020,
        '163': 1038,
        '164': 1020,
        '165': 1038,
        '166': 1020,
        '167': 1020,
        '168': 849,
        '169': 1709,
        '170': 852,
        '171': 1103,
        '172': 1020,
        '173': 627,
        '174': 1038,
        '175': 799,
        '176': 701,
        '177': 1020,
        '178': 692,
        '179': 688,
        '180': 616,
        '181': 1154,
        '182': 1224,
        '183': 548,
        '184': 621,
        '185': 517,
        '186': 891,
        '187': 1103,
        '188': 1347,
        '189': 1415,
        '190': 1437,
        '191': 949,
        '192': 1241,
        '193': 1241,
        '194': 1241,
        '195': 1241,
        '196': 1241,
        '197': 1241,
        '198': 1588,
        '199': 1084,
        '200': 999,
        '201': 999,
        '202': 999,
        '203': 999,
        '204': 546,
        '205': 546,
        '206': 546,
        '207': 546,
        '208': 1309,
        '209': 1349,
        '210': 1385,
        '211': 1385,
        '212': 1385,
        '213': 1385,
        '214': 1385,
        '215': 1020,
        '216': 1394,
        '217': 1337,
        '218': 1337,
        '219': 1337,
        '220': 1337,
        '221': 1064,
        '222': 1090,
        '223': 1136,
        '224': 1011,
        '225': 1011,
        '226': 1011,
        '227': 1011,
        '228': 1011,
        '229': 1011,
        '230': 1587,
        '231': 857,
        '232': 1031,
        '233': 1031,
        '234': 1031,
        '235': 1031,
        '236': 503,
        '237': 503,
        '238': 503,
        '239': 503,
        '240': 1099,
        '241': 1099,
        '242': 1101,
        '243': 1101,
        '244': 1101,
        '245': 1101,
        '246': 1101,
        '247': 1020,
        '248': 1114,
        '249': 1099,
        '250': 1099,
        '251': 1099,
        '252': 1099,
        '253': 970,
        '254': 1099,
        '255': 970,
        '8208': 627,
        '8210': 1038,
        '8211': 1020,
        '8212': 1854,
        '8213': 1854,
        '8214': 985,
        '8215': 1022,
        '8216': 528,
        '8217': 528,
        '8218': 528,
        '8219': 528,
        '8220': 891,
        '8221': 891,
        '8222': 891,
        '8223': 891,
        '8224': 1020,
        '8225': 1020,
        '8226': 1020,
        '8228': 547,
        '8230': 1457,
        '8482': 1475,
      },
    },
  },
  cambria: {
    regular: {
      upem: 2048,
      avg: 1260,
      isBold: false,
      adv: {
        '32': 451,
        '33': 585,
        '34': 805,
        '35': 1268,
        '36': 1036,
        '37': 1822,
        '38': 1408,
        '39': 485,
        '40': 782,
        '41': 782,
        '42': 875,
        '43': 1134,
        '44': 420,
        '45': 680,
        '46': 420,
        '47': 1004,
        '48': 1134,
        '49': 1134,
        '50': 1134,
        '51': 1134,
        '52': 1134,
        '53': 1134,
        '54': 1134,
        '55': 1134,
        '56': 1134,
        '57': 1134,
        '58': 540,
        '59': 540,
        '60': 1134,
        '61': 1134,
        '62': 1134,
        '63': 865,
        '64': 1813,
        '65': 1276,
        '66': 1252,
        '67': 1152,
        '68': 1355,
        '69': 1178,
        '70': 1099,
        '71': 1251,
        '72': 1406,
        '73': 664,
        '74': 628,
        '75': 1289,
        '76': 1099,
        '77': 1670,
        '78': 1394,
        '79': 1338,
        '80': 1163,
        '81': 1338,
        '82': 1272,
        '83': 1016,
        '84': 1214,
        '85': 1327,
        '86': 1236,
        '87': 1887,
        '88': 1170,
        '89': 1168,
        '90': 1101,
        '91': 717,
        '92': 1004,
        '93': 717,
        '94': 1134,
        '95': 759,
        '96': 583,
        '97': 1000,
        '98': 1121,
        '99': 903,
        '100': 1136,
        '101': 999,
        '102': 620,
        '103': 1012,
        '104': 1130,
        '105': 569,
        '106': 545,
        '107': 1074,
        '108': 556,
        '109': 1704,
        '110': 1143,
        '111': 1087,
        '112': 1139,
        '113': 1120,
        '114': 847,
        '115': 880,
        '116': 693,
        '117': 1131,
        '118': 1032,
        '119': 1586,
        '120': 990,
        '121': 1032,
        '122': 931,
        '123': 793,
        '124': 648,
        '125': 793,
        '126': 1459,
        '160': 451,
        '161': 585,
        '162': 903,
        '163': 1082,
        '164': 1114,
        '165': 1248,
        '166': 648,
        '167': 1024,
        '168': 583,
        '169': 1742,
        '170': 854,
        '171': 999,
        '172': 1134,
        '173': 680,
        '174': 1742,
        '175': 583,
        '176': 769,
        '177': 1134,
        '178': 834,
        '179': 834,
        '180': 583,
        '181': 1114,
        '182': 1204,
        '183': 578,
        '184': 583,
        '185': 834,
        '186': 876,
        '187': 999,
        '188': 1772,
        '189': 1822,
        '190': 1772,
        '191': 865,
        '192': 1276,
        '193': 1276,
        '194': 1276,
        '195': 1276,
        '196': 1276,
        '197': 1276,
        '198': 1774,
        '199': 1152,
        '200': 1178,
        '201': 1178,
        '202': 1178,
        '203': 1178,
        '204': 664,
        '205': 664,
        '206': 664,
        '207': 664,
        '208': 1361,
        '209': 1394,
        '210': 1338,
        '211': 1338,
        '212': 1338,
        '213': 1338,
        '214': 1338,
        '215': 1134,
        '216': 1338,
        '217': 1327,
        '218': 1327,
        '219': 1327,
        '220': 1327,
        '221': 1168,
        '222': 1175,
        '223': 1240,
        '224': 1000,
        '225': 1000,
        '226': 1000,
        '227': 1000,
        '228': 1000,
        '229': 1000,
        '230': 1541,
        '231': 903,
        '232': 999,
        '233': 999,
        '234': 999,
        '235': 999,
        '236': 569,
        '237': 569,
        '238': 569,
        '239': 569,
        '240': 1086,
        '241': 1143,
        '242': 1087,
        '243': 1087,
        '244': 1087,
        '245': 1087,
        '246': 1087,
        '247': 1134,
        '248': 1087,
        '249': 1131,
        '250': 1131,
        '251': 1131,
        '252': 1131,
        '253': 1032,
        '254': 1121,
        '255': 1032,
        '8208': 680,
        '8209': 680,
        '8210': 1114,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8214': 1083,
        '8215': 759,
        '8216': 453,
        '8217': 453,
        '8218': 420,
        '8219': 453,
        '8220': 769,
        '8221': 769,
        '8222': 738,
        '8223': 769,
        '8224': 1058,
        '8225': 1058,
        '8226': 908,
        '8228': 420,
        '8230': 1540,
        '8482': 1391,
      },
    },
    bold: {
      upem: 2048,
      avg: 1228,
      isBold: true,
      adv: {
        '32': 451,
        '33': 686,
        '34': 865,
        '35': 1265,
        '36': 1112,
        '37': 1998,
        '38': 1515,
        '39': 515,
        '40': 836,
        '41': 836,
        '42': 927,
        '43': 1213,
        '44': 475,
        '45': 690,
        '46': 475,
        '47': 1035,
        '48': 1213,
        '49': 1213,
        '50': 1213,
        '51': 1213,
        '52': 1213,
        '53': 1213,
        '54': 1213,
        '55': 1213,
        '56': 1213,
        '57': 1213,
        '58': 573,
        '59': 573,
        '60': 1213,
        '61': 1213,
        '62': 1213,
        '63': 925,
        '64': 1887,
        '65': 1335,
        '66': 1334,
        '67': 1174,
        '68': 1443,
        '69': 1183,
        '70': 1129,
        '71': 1324,
        '72': 1478,
        '73': 716,
        '74': 698,
        '75': 1396,
        '76': 1128,
        '77': 1733,
        '78': 1391,
        '79': 1424,
        '80': 1257,
        '81': 1424,
        '82': 1355,
        '83': 1051,
        '84': 1309,
        '85': 1385,
        '86': 1299,
        '87': 1969,
        '88': 1267,
        '89': 1238,
        '90': 1160,
        '91': 753,
        '92': 1035,
        '93': 753,
        '94': 1213,
        '95': 759,
        '96': 583,
        '97': 1096,
        '98': 1211,
        '99': 960,
        '100': 1223,
        '101': 1087,
        '102': 668,
        '103': 1065,
        '104': 1222,
        '105': 644,
        '106': 619,
        '107': 1212,
        '108': 631,
        '109': 1823,
        '110': 1236,
        '111': 1166,
        '112': 1223,
        '113': 1211,
        '114': 945,
        '115': 940,
        '116': 748,
        '117': 1223,
        '118': 1087,
        '119': 1635,
        '120': 1076,
        '121': 1087,
        '122': 981,
        '123': 804,
        '124': 656,
        '125': 804,
        '126': 1213,
        '160': 451,
        '161': 686,
        '162': 960,
        '163': 1138,
        '164': 1203,
        '165': 1313,
        '166': 656,
        '167': 1091,
        '168': 583,
        '169': 1742,
        '170': 860,
        '171': 1069,
        '172': 1213,
        '173': 690,
        '174': 1742,
        '175': 583,
        '176': 774,
        '177': 1213,
        '178': 895,
        '179': 895,
        '180': 583,
        '181': 1240,
        '182': 1204,
        '183': 565,
        '184': 583,
        '185': 895,
        '186': 892,
        '187': 1069,
        '188': 1928,
        '189': 1998,
        '190': 1928,
        '191': 925,
        '192': 1335,
        '193': 1335,
        '194': 1335,
        '195': 1335,
        '196': 1335,
        '197': 1335,
        '198': 1803,
        '199': 1174,
        '200': 1183,
        '201': 1183,
        '202': 1183,
        '203': 1183,
        '204': 716,
        '205': 716,
        '206': 716,
        '207': 716,
        '208': 1452,
        '209': 1391,
        '210': 1424,
        '211': 1424,
        '212': 1424,
        '213': 1424,
        '214': 1424,
        '215': 1213,
        '216': 1424,
        '217': 1385,
        '218': 1385,
        '219': 1385,
        '220': 1385,
        '221': 1238,
        '222': 1264,
        '223': 1386,
        '224': 1096,
        '225': 1096,
        '226': 1096,
        '227': 1096,
        '228': 1096,
        '229': 1096,
        '230': 1627,
        '231': 960,
        '232': 1087,
        '233': 1087,
        '234': 1087,
        '235': 1087,
        '236': 644,
        '237': 644,
        '238': 644,
        '239': 644,
        '240': 1171,
        '241': 1236,
        '242': 1166,
        '243': 1166,
        '244': 1166,
        '245': 1166,
        '246': 1166,
        '247': 1213,
        '248': 1166,
        '249': 1223,
        '250': 1223,
        '251': 1223,
        '252': 1223,
        '253': 1087,
        '254': 1211,
        '255': 1087,
        '8208': 690,
        '8209': 690,
        '8210': 1213,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8214': 1091,
        '8215': 759,
        '8216': 481,
        '8217': 481,
        '8218': 475,
        '8219': 481,
        '8220': 815,
        '8221': 815,
        '8222': 809,
        '8223': 815,
        '8224': 1058,
        '8225': 1058,
        '8226': 908,
        '8228': 475,
        '8230': 1582,
        '8482': 1401,
      },
    },
  },
  georgia: {
    regular: {
      upem: 2048,
      avg: 901,
      isBold: false,
      adv: {
        '32': 494,
        '33': 678,
        '34': 843,
        '35': 1317,
        '36': 1249,
        '37': 1674,
        '38': 1455,
        '39': 441,
        '40': 768,
        '41': 768,
        '42': 967,
        '43': 1317,
        '44': 552,
        '45': 766,
        '46': 552,
        '47': 960,
        '48': 1257,
        '49': 880,
        '50': 1144,
        '51': 1130,
        '52': 1157,
        '53': 1082,
        '54': 1159,
        '55': 1029,
        '56': 1221,
        '57': 1159,
        '58': 640,
        '59': 640,
        '60': 1317,
        '61': 1317,
        '62': 1317,
        '63': 980,
        '64': 1902,
        '65': 1374,
        '66': 1339,
        '67': 1315,
        '68': 1534,
        '69': 1338,
        '70': 1227,
        '71': 1485,
        '72': 1669,
        '73': 798,
        '74': 1060,
        '75': 1422,
        '76': 1236,
        '77': 1899,
        '78': 1571,
        '79': 1524,
        '80': 1249,
        '81': 1524,
        '82': 1437,
        '83': 1149,
        '84': 1267,
        '85': 1549,
        '86': 1365,
        '87': 1998,
        '88': 1455,
        '89': 1260,
        '90': 1232,
        '91': 768,
        '92': 960,
        '93': 768,
        '94': 1317,
        '95': 1317,
        '96': 1024,
        '97': 1032,
        '98': 1147,
        '99': 930,
        '100': 1176,
        '101': 990,
        '102': 666,
        '103': 1043,
        '104': 1192,
        '105': 600,
        '106': 598,
        '107': 1097,
        '108': 586,
        '109': 1804,
        '110': 1210,
        '111': 1104,
        '112': 1170,
        '113': 1146,
        '114': 839,
        '115': 885,
        '116': 707,
        '117': 1178,
        '118': 1017,
        '119': 1510,
        '120': 1034,
        '121': 1008,
        '122': 909,
        '123': 881,
        '124': 768,
        '125': 881,
        '126': 1317,
        '160': 494,
        '161': 678,
        '162': 1137,
        '163': 1274,
        '164': 1170,
        '165': 1259,
        '166': 768,
        '167': 1024,
        '168': 1024,
        '169': 1929,
        '170': 1024,
        '171': 1190,
        '172': 1317,
        '173': 766,
        '174': 1929,
        '175': 1317,
        '176': 859,
        '177': 1317,
        '178': 1024,
        '179': 1024,
        '180': 1024,
        '181': 1160,
        '182': 1024,
        '183': 572,
        '184': 1024,
        '185': 1024,
        '186': 1024,
        '187': 1190,
        '188': 2150,
        '189': 2150,
        '190': 2150,
        '191': 980,
        '192': 1374,
        '193': 1374,
        '194': 1374,
        '195': 1374,
        '196': 1374,
        '197': 1374,
        '198': 1988,
        '199': 1315,
        '200': 1338,
        '201': 1338,
        '202': 1338,
        '203': 1338,
        '204': 798,
        '205': 798,
        '206': 798,
        '207': 798,
        '208': 1534,
        '209': 1571,
        '210': 1524,
        '211': 1524,
        '212': 1524,
        '213': 1524,
        '214': 1524,
        '215': 1317,
        '216': 1524,
        '217': 1549,
        '218': 1549,
        '219': 1549,
        '220': 1549,
        '221': 1260,
        '222': 1258,
        '223': 1123,
        '224': 1032,
        '225': 1032,
        '226': 1032,
        '227': 1032,
        '228': 1032,
        '229': 1032,
        '230': 1509,
        '231': 930,
        '232': 990,
        '233': 990,
        '234': 990,
        '235': 990,
        '236': 600,
        '237': 600,
        '238': 600,
        '239': 600,
        '240': 1089,
        '241': 1210,
        '242': 1104,
        '243': 1104,
        '244': 1104,
        '245': 1104,
        '246': 1104,
        '247': 1317,
        '248': 1104,
        '249': 1178,
        '250': 1178,
        '251': 1178,
        '252': 1178,
        '253': 1008,
        '254': 1145,
        '255': 1008,
        '8211': 1317,
        '8212': 1755,
        '8213': 1755,
        '8215': 1317,
        '8216': 464,
        '8217': 464,
        '8218': 464,
        '8219': 400,
        '8220': 840,
        '8221': 840,
        '8222': 840,
        '8224': 967,
        '8225': 967,
        '8226': 804,
        '8230': 1653,
        '8482': 1930,
      },
    },
    bold: {
      upem: 2048,
      avg: 1051,
      isBold: true,
      adv: {
        '32': 520,
        '33': 771,
        '34': 1044,
        '35': 1440,
        '36': 1312,
        '37': 1801,
        '38': 1637,
        '39': 551,
        '40': 915,
        '41': 915,
        '42': 987,
        '43': 1440,
        '44': 672,
        '45': 776,
        '46': 672,
        '47': 966,
        '48': 1436,
        '49': 1003,
        '50': 1283,
        '51': 1279,
        '52': 1330,
        '53': 1227,
        '54': 1327,
        '55': 1135,
        '56': 1385,
        '57': 1327,
        '58': 752,
        '59': 752,
        '60': 1440,
        '61': 1440,
        '62': 1440,
        '63': 1123,
        '64': 1980,
        '65': 1553,
        '66': 1551,
        '67': 1465,
        '68': 1708,
        '69': 1477,
        '70': 1375,
        '71': 1653,
        '72': 1870,
        '73': 913,
        '74': 1219,
        '75': 1673,
        '76': 1404,
        '77': 2096,
        '78': 1719,
        '79': 1679,
        '80': 1436,
        '81': 1679,
        '82': 1633,
        '83': 1329,
        '84': 1401,
        '85': 1707,
        '86': 1561,
        '87': 2307,
        '88': 1656,
        '89': 1499,
        '90': 1412,
        '91': 915,
        '92': 966,
        '93': 915,
        '94': 1440,
        '95': 1440,
        '96': 1024,
        '97': 1220,
        '98': 1322,
        '99': 1088,
        '100': 1358,
        '101': 1171,
        '102': 805,
        '103': 1181,
        '104': 1392,
        '105': 724,
        '106': 709,
        '107': 1294,
        '108': 705,
        '109': 2080,
        '110': 1413,
        '111': 1302,
        '112': 1347,
        '113': 1328,
        '114': 1065,
        '115': 1050,
        '116': 814,
        '117': 1386,
        '118': 1161,
        '119': 1768,
        '120': 1204,
        '121': 1151,
        '122': 1076,
        '123': 1024,
        '124': 794,
        '125': 1024,
        '126': 1440,
        '160': 520,
        '161': 771,
        '162': 1240,
        '163': 1413,
        '164': 1440,
        '165': 1500,
        '166': 794,
        '167': 1154,
        '168': 1024,
        '169': 1929,
        '170': 1130,
        '171': 1250,
        '172': 1440,
        '173': 776,
        '174': 1929,
        '175': 1440,
        '176': 860,
        '177': 1440,
        '178': 1130,
        '179': 1130,
        '180': 1024,
        '181': 1368,
        '182': 1124,
        '183': 692,
        '184': 1024,
        '185': 1130,
        '186': 1130,
        '187': 1250,
        '188': 2194,
        '189': 2194,
        '190': 2194,
        '191': 1123,
        '192': 1553,
        '193': 1553,
        '194': 1553,
        '195': 1553,
        '196': 1553,
        '197': 1553,
        '198': 2191,
        '199': 1465,
        '200': 1477,
        '201': 1477,
        '202': 1477,
        '203': 1477,
        '204': 913,
        '205': 913,
        '206': 913,
        '207': 913,
        '208': 1708,
        '209': 1719,
        '210': 1679,
        '211': 1679,
        '212': 1679,
        '213': 1679,
        '214': 1679,
        '215': 1440,
        '216': 1679,
        '217': 1707,
        '218': 1707,
        '219': 1707,
        '220': 1707,
        '221': 1499,
        '222': 1450,
        '223': 1347,
        '224': 1220,
        '225': 1220,
        '226': 1220,
        '227': 1220,
        '228': 1220,
        '229': 1220,
        '230': 1756,
        '231': 1088,
        '232': 1171,
        '233': 1171,
        '234': 1171,
        '235': 1171,
        '236': 724,
        '237': 724,
        '238': 724,
        '239': 724,
        '240': 1306,
        '241': 1413,
        '242': 1302,
        '243': 1302,
        '244': 1302,
        '245': 1302,
        '246': 1302,
        '247': 1440,
        '248': 1302,
        '249': 1386,
        '250': 1386,
        '251': 1386,
        '252': 1386,
        '253': 1151,
        '254': 1321,
        '255': 1151,
        '8211': 1440,
        '8212': 1900,
        '8213': 1900,
        '8215': 1440,
        '8216': 550,
        '8217': 550,
        '8218': 550,
        '8219': 550,
        '8220': 1063,
        '8221': 1063,
        '8222': 1063,
        '8224': 987,
        '8225': 987,
        '8226': 896,
        '8230': 1929,
        '8482': 1940,
      },
    },
  },
  verdana: {
    regular: {
      upem: 2048,
      avg: 1041,
      isBold: false,
      adv: {
        '32': 720,
        '33': 806,
        '34': 940,
        '35': 1676,
        '36': 1302,
        '37': 2204,
        '38': 1488,
        '39': 550,
        '40': 930,
        '41': 930,
        '42': 1302,
        '43': 1676,
        '44': 745,
        '45': 930,
        '46': 745,
        '47': 930,
        '48': 1302,
        '49': 1302,
        '50': 1302,
        '51': 1302,
        '52': 1302,
        '53': 1302,
        '54': 1302,
        '55': 1302,
        '56': 1302,
        '57': 1302,
        '58': 930,
        '59': 930,
        '60': 1676,
        '61': 1676,
        '62': 1676,
        '63': 1117,
        '64': 2048,
        '65': 1400,
        '66': 1404,
        '67': 1430,
        '68': 1578,
        '69': 1295,
        '70': 1177,
        '71': 1588,
        '72': 1539,
        '73': 862,
        '74': 931,
        '75': 1419,
        '76': 1140,
        '77': 1726,
        '78': 1532,
        '79': 1612,
        '80': 1235,
        '81': 1612,
        '82': 1424,
        '83': 1400,
        '84': 1262,
        '85': 1499,
        '86': 1400,
        '87': 2025,
        '88': 1403,
        '89': 1260,
        '90': 1403,
        '91': 930,
        '92': 930,
        '93': 930,
        '94': 1676,
        '95': 1302,
        '96': 1302,
        '97': 1230,
        '98': 1276,
        '99': 1067,
        '100': 1276,
        '101': 1220,
        '102': 720,
        '103': 1276,
        '104': 1296,
        '105': 562,
        '106': 705,
        '107': 1212,
        '108': 562,
        '109': 1992,
        '110': 1296,
        '111': 1243,
        '112': 1276,
        '113': 1276,
        '114': 874,
        '115': 1067,
        '116': 807,
        '117': 1296,
        '118': 1212,
        '119': 1676,
        '120': 1212,
        '121': 1212,
        '122': 1076,
        '123': 1300,
        '124': 930,
        '125': 1300,
        '126': 1676,
        '160': 720,
        '161': 806,
        '162': 1302,
        '163': 1302,
        '164': 1302,
        '165': 1302,
        '166': 930,
        '167': 1302,
        '168': 1302,
        '169': 2048,
        '170': 1117,
        '171': 1320,
        '172': 1676,
        '173': 930,
        '174': 2048,
        '175': 1302,
        '176': 1110,
        '177': 1676,
        '178': 1110,
        '179': 1110,
        '180': 1302,
        '181': 1314,
        '182': 1302,
        '183': 745,
        '184': 1302,
        '185': 1110,
        '186': 1117,
        '187': 1320,
        '188': 2048,
        '189': 2048,
        '190': 2048,
        '191': 1117,
        '192': 1400,
        '193': 1400,
        '194': 1400,
        '195': 1400,
        '196': 1400,
        '197': 1400,
        '198': 2016,
        '199': 1430,
        '200': 1295,
        '201': 1295,
        '202': 1295,
        '203': 1295,
        '204': 862,
        '205': 862,
        '206': 862,
        '207': 862,
        '208': 1588,
        '209': 1532,
        '210': 1612,
        '211': 1612,
        '212': 1612,
        '213': 1612,
        '214': 1612,
        '215': 1676,
        '216': 1612,
        '217': 1499,
        '218': 1499,
        '219': 1499,
        '220': 1499,
        '221': 1260,
        '222': 1240,
        '223': 1270,
        '224': 1230,
        '225': 1230,
        '226': 1230,
        '227': 1230,
        '228': 1230,
        '229': 1230,
        '230': 1956,
        '231': 1067,
        '232': 1220,
        '233': 1220,
        '234': 1220,
        '235': 1220,
        '236': 562,
        '237': 562,
        '238': 562,
        '239': 562,
        '240': 1253,
        '241': 1296,
        '242': 1243,
        '243': 1243,
        '244': 1243,
        '245': 1243,
        '246': 1243,
        '247': 1676,
        '248': 1243,
        '249': 1296,
        '250': 1296,
        '251': 1296,
        '252': 1296,
        '253': 1212,
        '254': 1276,
        '255': 1212,
        '8210': 1302,
        '8211': 1302,
        '8212': 2048,
        '8213': 2048,
        '8215': 1302,
        '8216': 550,
        '8217': 550,
        '8218': 550,
        '8219': 550,
        '8220': 940,
        '8221': 940,
        '8222': 940,
        '8223': 940,
        '8224': 1302,
        '8225': 1302,
        '8226': 1117,
        '8230': 1676,
        '8482': 2000,
      },
    },
    bold: {
      upem: 2048,
      avg: 1163,
      isBold: true,
      adv: {
        '32': 700,
        '33': 824,
        '34': 1203,
        '35': 1776,
        '36': 1456,
        '37': 2605,
        '38': 1766,
        '39': 680,
        '40': 1113,
        '41': 1113,
        '42': 1456,
        '43': 1776,
        '44': 740,
        '45': 983,
        '46': 740,
        '47': 1412,
        '48': 1456,
        '49': 1456,
        '50': 1456,
        '51': 1456,
        '52': 1456,
        '53': 1456,
        '54': 1456,
        '55': 1456,
        '56': 1456,
        '57': 1456,
        '58': 824,
        '59': 824,
        '60': 1776,
        '61': 1776,
        '62': 1776,
        '63': 1263,
        '64': 1974,
        '65': 1590,
        '66': 1560,
        '67': 1482,
        '68': 1700,
        '69': 1399,
        '70': 1332,
        '71': 1661,
        '72': 1715,
        '73': 1118,
        '74': 1137,
        '75': 1579,
        '76': 1305,
        '77': 1941,
        '78': 1734,
        '79': 1741,
        '80': 1501,
        '81': 1741,
        '82': 1602,
        '83': 1455,
        '84': 1396,
        '85': 1663,
        '86': 1564,
        '87': 2311,
        '88': 1564,
        '89': 1509,
        '90': 1417,
        '91': 1113,
        '92': 1412,
        '93': 1113,
        '94': 1776,
        '95': 1456,
        '96': 1456,
        '97': 1368,
        '98': 1432,
        '99': 1205,
        '100': 1432,
        '101': 1360,
        '102': 865,
        '103': 1432,
        '104': 1459,
        '105': 700,
        '106': 825,
        '107': 1374,
        '108': 700,
        '109': 2167,
        '110': 1459,
        '111': 1406,
        '112': 1432,
        '113': 1432,
        '114': 1018,
        '115': 1215,
        '116': 933,
        '117': 1459,
        '118': 1331,
        '119': 2006,
        '120': 1370,
        '121': 1333,
        '122': 1222,
        '123': 1456,
        '124': 1113,
        '125': 1456,
        '126': 1776,
        '160': 700,
        '161': 824,
        '162': 1456,
        '163': 1456,
        '164': 1456,
        '165': 1456,
        '166': 1113,
        '167': 1456,
        '168': 1456,
        '169': 1974,
        '170': 1224,
        '171': 1740,
        '172': 1776,
        '173': 983,
        '174': 1974,
        '175': 1456,
        '176': 1203,
        '177': 1776,
        '178': 1224,
        '179': 1224,
        '180': 1456,
        '181': 1477,
        '182': 1456,
        '183': 740,
        '184': 1456,
        '185': 1224,
        '186': 1224,
        '187': 1740,
        '188': 2420,
        '189': 2420,
        '190': 2420,
        '191': 1263,
        '192': 1590,
        '193': 1590,
        '194': 1590,
        '195': 1590,
        '196': 1590,
        '197': 1590,
        '198': 2240,
        '199': 1482,
        '200': 1399,
        '201': 1399,
        '202': 1399,
        '203': 1399,
        '204': 1118,
        '205': 1118,
        '206': 1118,
        '207': 1118,
        '208': 1700,
        '209': 1734,
        '210': 1741,
        '211': 1741,
        '212': 1741,
        '213': 1741,
        '214': 1741,
        '215': 1776,
        '216': 1741,
        '217': 1663,
        '218': 1663,
        '219': 1663,
        '220': 1663,
        '221': 1509,
        '222': 1505,
        '223': 1460,
        '224': 1368,
        '225': 1368,
        '226': 1368,
        '227': 1368,
        '228': 1368,
        '229': 1368,
        '230': 2085,
        '231': 1205,
        '232': 1360,
        '233': 1360,
        '234': 1360,
        '235': 1360,
        '236': 700,
        '237': 700,
        '238': 700,
        '239': 700,
        '240': 1391,
        '241': 1459,
        '242': 1406,
        '243': 1406,
        '244': 1406,
        '245': 1406,
        '246': 1406,
        '247': 1776,
        '248': 1406,
        '249': 1459,
        '250': 1459,
        '251': 1459,
        '252': 1459,
        '253': 1333,
        '254': 1432,
        '255': 1333,
        '8210': 1456,
        '8211': 1456,
        '8212': 2048,
        '8213': 2048,
        '8215': 1456,
        '8216': 680,
        '8217': 680,
        '8218': 680,
        '8219': 680,
        '8220': 1203,
        '8221': 1203,
        '8222': 1203,
        '8223': 1203,
        '8224': 1456,
        '8225': 1456,
        '8226': 1456,
        '8230': 2148,
        '8482': 1974,
      },
    },
  },
  tahoma: {
    regular: {
      upem: 2048,
      avg: 910,
      isBold: false,
      adv: {
        '32': 640,
        '33': 680,
        '34': 822,
        '35': 1490,
        '36': 1118,
        '37': 2000,
        '38': 1380,
        '39': 432,
        '40': 784,
        '41': 784,
        '42': 1118,
        '43': 1490,
        '44': 620,
        '45': 744,
        '46': 620,
        '47': 783,
        '48': 1118,
        '49': 1118,
        '50': 1118,
        '51': 1118,
        '52': 1118,
        '53': 1118,
        '54': 1118,
        '55': 1118,
        '56': 1118,
        '57': 1118,
        '58': 724,
        '59': 724,
        '60': 1490,
        '61': 1490,
        '62': 1490,
        '63': 970,
        '64': 1862,
        '65': 1228,
        '66': 1207,
        '67': 1230,
        '68': 1389,
        '69': 1149,
        '70': 1068,
        '71': 1367,
        '72': 1383,
        '73': 764,
        '74': 853,
        '75': 1204,
        '76': 1019,
        '77': 1578,
        '78': 1367,
        '79': 1449,
        '80': 1129,
        '81': 1449,
        '82': 1271,
        '83': 1141,
        '84': 1196,
        '85': 1343,
        '86': 1222,
        '87': 1847,
        '88': 1189,
        '89': 1180,
        '90': 1145,
        '91': 784,
        '92': 783,
        '93': 784,
        '94': 1490,
        '95': 1118,
        '96': 1118,
        '97': 1075,
        '98': 1132,
        '99': 945,
        '100': 1132,
        '101': 1078,
        '102': 652,
        '103': 1132,
        '104': 1142,
        '105': 468,
        '106': 577,
        '107': 1020,
        '108': 468,
        '109': 1720,
        '110': 1142,
        '111': 1112,
        '112': 1132,
        '113': 1132,
        '114': 738,
        '115': 914,
        '116': 685,
        '117': 1142,
        '118': 1020,
        '119': 1520,
        '120': 1014,
        '121': 1020,
        '122': 910,
        '123': 984,
        '124': 783,
        '125': 984,
        '126': 1490,
        '160': 640,
        '161': 680,
        '162': 1118,
        '163': 1118,
        '164': 1118,
        '165': 1118,
        '166': 783,
        '167': 1118,
        '168': 1118,
        '169': 1902,
        '170': 1010,
        '171': 1174,
        '172': 1490,
        '173': 744,
        '174': 1902,
        '175': 1118,
        '176': 964,
        '177': 1490,
        '178': 1010,
        '179': 1010,
        '180': 1118,
        '181': 1163,
        '182': 1118,
        '183': 724,
        '184': 1118,
        '185': 1010,
        '186': 1010,
        '187': 1174,
        '188': 2048,
        '189': 2048,
        '190': 2048,
        '191': 970,
        '192': 1228,
        '193': 1228,
        '194': 1228,
        '195': 1228,
        '196': 1228,
        '197': 1228,
        '198': 1870,
        '199': 1230,
        '200': 1149,
        '201': 1149,
        '202': 1149,
        '203': 1149,
        '204': 764,
        '205': 764,
        '206': 764,
        '207': 764,
        '208': 1430,
        '209': 1367,
        '210': 1449,
        '211': 1449,
        '212': 1449,
        '213': 1449,
        '214': 1449,
        '215': 1490,
        '216': 1449,
        '217': 1343,
        '218': 1343,
        '219': 1343,
        '220': 1343,
        '221': 1180,
        '222': 1158,
        '223': 1123,
        '224': 1075,
        '225': 1075,
        '226': 1075,
        '227': 1075,
        '228': 1075,
        '229': 1075,
        '230': 1802,
        '231': 945,
        '232': 1078,
        '233': 1078,
        '234': 1078,
        '235': 1078,
        '236': 468,
        '237': 468,
        '238': 468,
        '239': 468,
        '240': 1118,
        '241': 1142,
        '242': 1112,
        '243': 1112,
        '244': 1112,
        '245': 1112,
        '246': 1112,
        '247': 1490,
        '248': 1112,
        '249': 1142,
        '250': 1142,
        '251': 1142,
        '252': 1142,
        '253': 1020,
        '254': 1132,
        '255': 1020,
        '8208': 744,
        '8209': 744,
        '8210': 1118,
        '8211': 1118,
        '8212': 1862,
        '8213': 1862,
        '8214': 783,
        '8215': 1118,
        '8216': 432,
        '8217': 432,
        '8218': 432,
        '8219': 432,
        '8220': 822,
        '8221': 822,
        '8222': 814,
        '8223': 822,
        '8224': 1118,
        '8225': 1118,
        '8226': 931,
        '8227': 931,
        '8228': 558,
        '8229': 1116,
        '8230': 1674,
        '8482': 1794,
      },
    },
    bold: {
      upem: 2048,
      avg: 1036,
      isBold: true,
      adv: {
        '32': 600,
        '33': 702,
        '34': 1002,
        '35': 1676,
        '36': 1304,
        '37': 2455,
        '38': 1600,
        '39': 564,
        '40': 930,
        '41': 930,
        '42': 1304,
        '43': 1676,
        '44': 640,
        '45': 883,
        '46': 640,
        '47': 1182,
        '48': 1304,
        '49': 1304,
        '50': 1304,
        '51': 1304,
        '52': 1304,
        '53': 1304,
        '54': 1304,
        '55': 1304,
        '56': 1304,
        '57': 1304,
        '58': 744,
        '59': 744,
        '60': 1676,
        '61': 1676,
        '62': 1676,
        '63': 1160,
        '64': 1884,
        '65': 1402,
        '66': 1405,
        '67': 1367,
        '68': 1551,
        '69': 1260,
        '70': 1190,
        '71': 1526,
        '72': 1565,
        '73': 990,
        '74': 1025,
        '75': 1426,
        '76': 1172,
        '77': 1829,
        '78': 1578,
        '79': 1577,
        '80': 1346,
        '81': 1577,
        '82': 1487,
        '83': 1297,
        '84': 1254,
        '85': 1513,
        '86': 1382,
        '87': 2105,
        '88': 1402,
        '89': 1373,
        '90': 1275,
        '91': 930,
        '92': 1182,
        '93': 930,
        '94': 1676,
        '95': 1304,
        '96': 1118,
        '97': 1226,
        '98': 1294,
        '99': 1080,
        '100': 1289,
        '101': 1216,
        '102': 783,
        '103': 1289,
        '104': 1311,
        '105': 618,
        '106': 743,
        '107': 1234,
        '108': 618,
        '109': 1953,
        '110': 1311,
        '111': 1264,
        '112': 1289,
        '113': 1289,
        '114': 888,
        '115': 1054,
        '116': 851,
        '117': 1311,
        '118': 1185,
        '119': 1822,
        '120': 1238,
        '121': 1179,
        '122': 1077,
        '123': 1276,
        '124': 1304,
        '125': 1276,
        '126': 1676,
        '160': 600,
        '161': 702,
        '162': 1304,
        '163': 1304,
        '164': 1304,
        '165': 1304,
        '166': 1304,
        '167': 1304,
        '168': 1118,
        '169': 1902,
        '170': 1040,
        '171': 1440,
        '172': 1676,
        '173': 883,
        '174': 1902,
        '175': 1304,
        '176': 1064,
        '177': 1676,
        '178': 1104,
        '179': 1104,
        '180': 1118,
        '181': 1333,
        '182': 1304,
        '183': 744,
        '184': 1118,
        '185': 1104,
        '186': 1104,
        '187': 1440,
        '188': 2310,
        '189': 2310,
        '190': 2310,
        '191': 1160,
        '192': 1402,
        '193': 1402,
        '194': 1402,
        '195': 1402,
        '196': 1402,
        '197': 1402,
        '198': 2025,
        '199': 1367,
        '200': 1260,
        '201': 1260,
        '202': 1260,
        '203': 1260,
        '204': 990,
        '205': 990,
        '206': 990,
        '207': 990,
        '208': 1585,
        '209': 1578,
        '210': 1577,
        '211': 1577,
        '212': 1577,
        '213': 1577,
        '214': 1577,
        '215': 1676,
        '216': 1577,
        '217': 1513,
        '218': 1513,
        '219': 1513,
        '220': 1513,
        '221': 1373,
        '222': 1350,
        '223': 1322,
        '224': 1226,
        '225': 1226,
        '226': 1226,
        '227': 1226,
        '228': 1226,
        '229': 1226,
        '230': 1919,
        '231': 1080,
        '232': 1216,
        '233': 1216,
        '234': 1216,
        '235': 1216,
        '236': 618,
        '237': 618,
        '238': 618,
        '239': 618,
        '240': 1269,
        '241': 1311,
        '242': 1264,
        '243': 1264,
        '244': 1264,
        '245': 1264,
        '246': 1264,
        '247': 1676,
        '248': 1264,
        '249': 1311,
        '250': 1311,
        '251': 1311,
        '252': 1311,
        '253': 1179,
        '254': 1289,
        '255': 1179,
        '8208': 883,
        '8209': 883,
        '8210': 1304,
        '8211': 1304,
        '8212': 1862,
        '8213': 1862,
        '8214': 1304,
        '8215': 1304,
        '8216': 564,
        '8217': 564,
        '8218': 564,
        '8219': 564,
        '8220': 1002,
        '8221': 1002,
        '8222': 1002,
        '8223': 1002,
        '8224': 1304,
        '8225': 1304,
        '8226': 1304,
        '8227': 1304,
        '8228': 682,
        '8229': 1365,
        '8230': 2048,
        '8482': 1763,
      },
    },
  },
  garamond: {
    regular: {
      upem: 2048,
      avg: 793,
      isBold: false,
      adv: {
        '32': 512,
        '33': 448,
        '34': 832,
        '35': 1365,
        '36': 917,
        '37': 1685,
        '38': 1493,
        '39': 363,
        '40': 597,
        '41': 597,
        '42': 875,
        '43': 1365,
        '44': 448,
        '45': 640,
        '46': 448,
        '47': 1024,
        '48': 960,
        '49': 960,
        '50': 960,
        '51': 960,
        '52': 960,
        '53': 960,
        '54': 960,
        '55': 960,
        '56': 960,
        '57': 960,
        '58': 448,
        '59': 448,
        '60': 1365,
        '61': 1365,
        '62': 1365,
        '63': 747,
        '64': 1877,
        '65': 1387,
        '66': 1259,
        '67': 1301,
        '68': 1579,
        '69': 1344,
        '70': 1152,
        '71': 1579,
        '72': 1557,
        '73': 725,
        '74': 683,
        '75': 1515,
        '76': 1173,
        '77': 1707,
        '78': 1579,
        '79': 1600,
        '80': 1152,
        '81': 1579,
        '82': 1280,
        '83': 981,
        '84': 1259,
        '85': 1451,
        '86': 1387,
        '87': 1813,
        '88': 1429,
        '89': 1344,
        '90': 1344,
        '91': 555,
        '92': 1024,
        '93': 555,
        '94': 1024,
        '95': 1024,
        '96': 683,
        '97': 832,
        '98': 1045,
        '99': 853,
        '100': 1024,
        '101': 853,
        '102': 661,
        '103': 917,
        '104': 1045,
        '105': 469,
        '106': 469,
        '107': 960,
        '108': 469,
        '109': 1579,
        '110': 1045,
        '111': 1045,
        '112': 1045,
        '113': 1003,
        '114': 683,
        '115': 747,
        '116': 597,
        '117': 1003,
        '118': 960,
        '119': 1365,
        '120': 939,
        '121': 853,
        '122': 875,
        '123': 981,
        '124': 1024,
        '125': 981,
        '126': 1365,
        '160': 512,
        '161': 448,
        '162': 853,
        '163': 1173,
        '164': 1387,
        '165': 1344,
        '166': 1024,
        '167': 875,
        '168': 683,
        '169': 1557,
        '170': 533,
        '171': 747,
        '172': 1365,
        '173': 640,
        '174': 1557,
        '175': 1024,
        '176': 811,
        '177': 1365,
        '178': 640,
        '179': 640,
        '180': 683,
        '181': 1024,
        '182': 917,
        '183': 683,
        '184': 683,
        '185': 640,
        '186': 683,
        '187': 747,
        '188': 1664,
        '189': 1664,
        '190': 1685,
        '191': 747,
        '192': 1387,
        '193': 1387,
        '194': 1387,
        '195': 1387,
        '196': 1387,
        '197': 1387,
        '198': 1749,
        '199': 1301,
        '200': 1344,
        '201': 1344,
        '202': 1344,
        '203': 1344,
        '204': 725,
        '205': 725,
        '206': 725,
        '207': 725,
        '208': 1579,
        '209': 1579,
        '210': 1600,
        '211': 1600,
        '212': 1600,
        '213': 1600,
        '214': 1600,
        '215': 1365,
        '216': 1600,
        '217': 1451,
        '218': 1451,
        '219': 1451,
        '220': 1451,
        '221': 1344,
        '222': 1152,
        '223': 1024,
        '224': 832,
        '225': 832,
        '226': 832,
        '227': 832,
        '228': 832,
        '229': 832,
        '230': 1195,
        '231': 853,
        '232': 853,
        '233': 853,
        '234': 853,
        '235': 853,
        '236': 469,
        '237': 469,
        '238': 469,
        '239': 469,
        '240': 1067,
        '241': 1045,
        '242': 1045,
        '243': 1045,
        '244': 1045,
        '245': 1045,
        '246': 1045,
        '247': 1124,
        '248': 1045,
        '249': 1003,
        '250': 1003,
        '251': 1003,
        '252': 1003,
        '253': 853,
        '254': 1045,
        '255': 853,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8215': 1024,
        '8216': 448,
        '8217': 448,
        '8218': 448,
        '8219': 448,
        '8220': 917,
        '8221': 917,
        '8222': 917,
        '8224': 875,
        '8225': 875,
        '8226': 725,
        '8230': 2048,
        '8482': 2005,
      },
    },
    bold: {
      upem: 2048,
      avg: 865,
      isBold: true,
      adv: {
        '32': 512,
        '33': 533,
        '34': 1131,
        '35': 1365,
        '36': 960,
        '37': 1707,
        '38': 1643,
        '39': 576,
        '40': 725,
        '41': 725,
        '42': 1003,
        '43': 1365,
        '44': 533,
        '45': 683,
        '46': 533,
        '47': 1131,
        '48': 960,
        '49': 811,
        '50': 960,
        '51': 960,
        '52': 960,
        '53': 960,
        '54': 960,
        '55': 960,
        '56': 960,
        '57': 960,
        '58': 533,
        '59': 533,
        '60': 1365,
        '61': 1365,
        '62': 1365,
        '63': 853,
        '64': 1899,
        '65': 1344,
        '66': 1387,
        '67': 1387,
        '68': 1600,
        '69': 1451,
        '70': 1259,
        '71': 1493,
        '72': 1771,
        '73': 811,
        '74': 768,
        '75': 1387,
        '76': 1301,
        '77': 1877,
        '78': 1728,
        '79': 1621,
        '80': 1259,
        '81': 1621,
        '82': 1429,
        '83': 1045,
        '84': 1408,
        '85': 1557,
        '86': 1365,
        '87': 1835,
        '88': 1408,
        '89': 1344,
        '90': 1365,
        '91': 747,
        '92': 1131,
        '93': 747,
        '94': 1195,
        '95': 1024,
        '96': 683,
        '97': 981,
        '98': 1131,
        '99': 960,
        '100': 1131,
        '101': 960,
        '102': 619,
        '103': 1109,
        '104': 1131,
        '105': 576,
        '106': 533,
        '107': 1088,
        '108': 533,
        '109': 1728,
        '110': 1131,
        '111': 1067,
        '112': 1131,
        '113': 1131,
        '114': 704,
        '115': 853,
        '116': 640,
        '117': 1131,
        '118': 939,
        '119': 1451,
        '120': 1024,
        '121': 960,
        '122': 960,
        '123': 811,
        '124': 1109,
        '125': 811,
        '126': 1365,
        '160': 512,
        '161': 533,
        '162': 960,
        '163': 1387,
        '164': 1408,
        '165': 1344,
        '166': 1109,
        '167': 1024,
        '168': 683,
        '169': 1536,
        '170': 619,
        '171': 939,
        '172': 1365,
        '173': 683,
        '174': 1536,
        '175': 1024,
        '176': 811,
        '177': 1365,
        '178': 640,
        '179': 640,
        '180': 683,
        '181': 939,
        '182': 1109,
        '183': 683,
        '184': 683,
        '185': 640,
        '186': 683,
        '187': 939,
        '188': 1707,
        '189': 1707,
        '190': 1707,
        '191': 853,
        '192': 1344,
        '193': 1344,
        '194': 1344,
        '195': 1344,
        '196': 1344,
        '197': 1344,
        '198': 1877,
        '199': 1387,
        '200': 1451,
        '201': 1451,
        '202': 1451,
        '203': 1451,
        '204': 811,
        '205': 811,
        '206': 811,
        '207': 811,
        '208': 1600,
        '209': 1728,
        '210': 1621,
        '211': 1621,
        '212': 1621,
        '213': 1621,
        '214': 1621,
        '215': 1365,
        '216': 1621,
        '217': 1557,
        '218': 1557,
        '219': 1557,
        '220': 1557,
        '221': 1344,
        '222': 1259,
        '223': 1109,
        '224': 981,
        '225': 981,
        '226': 981,
        '227': 981,
        '228': 981,
        '229': 981,
        '230': 1429,
        '231': 960,
        '232': 960,
        '233': 960,
        '234': 960,
        '235': 960,
        '236': 576,
        '237': 576,
        '238': 576,
        '239': 576,
        '240': 1067,
        '241': 1131,
        '242': 1067,
        '243': 1067,
        '244': 1067,
        '245': 1067,
        '246': 1067,
        '247': 1365,
        '248': 1067,
        '249': 1131,
        '250': 1131,
        '251': 1131,
        '252': 1131,
        '253': 960,
        '254': 1131,
        '255': 960,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8215': 1024,
        '8216': 512,
        '8217': 512,
        '8218': 512,
        '8219': 512,
        '8220': 1003,
        '8221': 1003,
        '8222': 1003,
        '8224': 1024,
        '8225': 1024,
        '8226': 725,
        '8230': 2048,
        '8482': 2048,
      },
    },
  },
  'book antiqua': {
    regular: {
      upem: 2048,
      avg: 912,
      isBold: false,
      adv: {
        '32': 512,
        '33': 569,
        '34': 760,
        '35': 1241,
        '36': 1024,
        '37': 1720,
        '38': 1593,
        '39': 426,
        '40': 682,
        '41': 682,
        '42': 797,
        '43': 1241,
        '44': 512,
        '45': 682,
        '46': 512,
        '47': 1241,
        '48': 1024,
        '49': 1024,
        '50': 1024,
        '51': 1024,
        '52': 1024,
        '53': 1024,
        '54': 1024,
        '55': 1024,
        '56': 1024,
        '57': 1024,
        '58': 512,
        '59': 512,
        '60': 1241,
        '61': 1241,
        '62': 1241,
        '63': 909,
        '64': 1530,
        '65': 1593,
        '66': 1251,
        '67': 1452,
        '68': 1585,
        '69': 1251,
        '70': 1139,
        '71': 1563,
        '72': 1704,
        '73': 690,
        '74': 682,
        '75': 1487,
        '76': 1251,
        '77': 1937,
        '78': 1702,
        '79': 1610,
        '80': 1237,
        '81': 1610,
        '82': 1368,
        '83': 1075,
        '84': 1255,
        '85': 1593,
        '86': 1479,
        '87': 2048,
        '88': 1366,
        '89': 1366,
        '90': 1366,
        '91': 682,
        '92': 1241,
        '93': 682,
        '94': 1241,
        '95': 1024,
        '96': 682,
        '97': 1024,
        '98': 1133,
        '99': 909,
        '100': 1251,
        '101': 981,
        '102': 682,
        '103': 1139,
        '104': 1192,
        '105': 596,
        '106': 479,
        '107': 1139,
        '108': 596,
        '109': 1808,
        '110': 1192,
        '111': 1118,
        '112': 1231,
        '113': 1147,
        '114': 809,
        '115': 868,
        '116': 668,
        '117': 1235,
        '118': 1157,
        '119': 1708,
        '120': 1057,
        '121': 1139,
        '122': 1024,
        '123': 682,
        '124': 1241,
        '125': 682,
        '126': 1241,
        '160': 512,
        '161': 569,
        '162': 1024,
        '163': 1024,
        '164': 1241,
        '165': 1024,
        '166': 1241,
        '167': 1024,
        '168': 682,
        '169': 1530,
        '170': 682,
        '171': 1024,
        '172': 1241,
        '173': 682,
        '174': 1530,
        '175': 1024,
        '176': 819,
        '177': 1124,
        '178': 635,
        '179': 635,
        '180': 682,
        '181': 1180,
        '182': 1286,
        '183': 682,
        '184': 682,
        '185': 635,
        '186': 682,
        '187': 1024,
        '188': 1612,
        '189': 1612,
        '190': 1612,
        '191': 909,
        '192': 1593,
        '193': 1593,
        '194': 1593,
        '195': 1593,
        '196': 1593,
        '197': 1593,
        '198': 1933,
        '199': 1452,
        '200': 1251,
        '201': 1251,
        '202': 1251,
        '203': 1251,
        '204': 690,
        '205': 690,
        '206': 690,
        '207': 690,
        '208': 1585,
        '209': 1702,
        '210': 1610,
        '211': 1610,
        '212': 1610,
        '213': 1610,
        '214': 1610,
        '215': 1241,
        '216': 1706,
        '217': 1593,
        '218': 1593,
        '219': 1593,
        '220': 1593,
        '221': 1366,
        '222': 1237,
        '223': 1139,
        '224': 1024,
        '225': 1024,
        '226': 1024,
        '227': 1024,
        '228': 1024,
        '229': 1024,
        '230': 1552,
        '231': 909,
        '232': 981,
        '233': 981,
        '234': 981,
        '235': 981,
        '236': 588,
        '237': 588,
        '238': 588,
        '239': 588,
        '240': 1118,
        '241': 1192,
        '242': 1118,
        '243': 1118,
        '244': 1118,
        '245': 1118,
        '246': 1118,
        '247': 1124,
        '248': 1139,
        '249': 1235,
        '250': 1235,
        '251': 1235,
        '252': 1235,
        '253': 1139,
        '254': 1231,
        '255': 1139,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8215': 1024,
        '8216': 569,
        '8217': 569,
        '8218': 569,
        '8219': 569,
        '8220': 1024,
        '8221': 1024,
        '8222': 1024,
        '8224': 1024,
        '8225': 1024,
        '8226': 1241,
        '8230': 2048,
        '8482': 2005,
      },
    },
    bold: {
      upem: 2048,
      avg: 940,
      isBold: true,
      adv: {
        '32': 512,
        '33': 569,
        '34': 823,
        '35': 1241,
        '36': 1024,
        '37': 1821,
        '38': 1706,
        '39': 465,
        '40': 682,
        '41': 682,
        '42': 909,
        '43': 1241,
        '44': 512,
        '45': 682,
        '46': 512,
        '47': 606,
        '48': 1024,
        '49': 1024,
        '50': 1024,
        '51': 1024,
        '52': 1024,
        '53': 1024,
        '54': 1024,
        '55': 1024,
        '56': 1024,
        '57': 1024,
        '58': 512,
        '59': 512,
        '60': 1241,
        '61': 1241,
        '62': 1241,
        '63': 909,
        '64': 1530,
        '65': 1593,
        '66': 1366,
        '67': 1479,
        '68': 1706,
        '69': 1251,
        '70': 1139,
        '71': 1706,
        '72': 1706,
        '73': 797,
        '74': 797,
        '75': 1593,
        '76': 1251,
        '77': 2048,
        '78': 1706,
        '79': 1706,
        '80': 1251,
        '81': 1706,
        '82': 1479,
        '83': 1251,
        '84': 1366,
        '85': 1593,
        '86': 1593,
        '87': 2048,
        '88': 1366,
        '89': 1366,
        '90': 1366,
        '91': 682,
        '92': 1241,
        '93': 682,
        '94': 1241,
        '95': 1024,
        '96': 682,
        '97': 1024,
        '98': 1251,
        '99': 909,
        '100': 1251,
        '101': 1024,
        '102': 797,
        '103': 1139,
        '104': 1251,
        '105': 682,
        '106': 682,
        '107': 1251,
        '108': 682,
        '109': 1821,
        '110': 1251,
        '111': 1139,
        '112': 1251,
        '113': 1251,
        '114': 797,
        '115': 909,
        '116': 682,
        '117': 1251,
        '118': 1139,
        '119': 1706,
        '120': 1024,
        '121': 1139,
        '122': 1024,
        '123': 635,
        '124': 1241,
        '125': 635,
        '126': 1241,
        '160': 512,
        '161': 569,
        '162': 1024,
        '163': 1024,
        '164': 1241,
        '165': 1024,
        '166': 1241,
        '167': 1024,
        '168': 682,
        '169': 1530,
        '170': 897,
        '171': 1024,
        '172': 1241,
        '173': 682,
        '174': 1530,
        '175': 1024,
        '176': 819,
        '177': 1124,
        '178': 739,
        '179': 739,
        '180': 682,
        '181': 1180,
        '182': 1313,
        '183': 682,
        '184': 682,
        '185': 739,
        '186': 999,
        '187': 1024,
        '188': 1821,
        '189': 1823,
        '190': 1821,
        '191': 909,
        '192': 1593,
        '193': 1593,
        '194': 1593,
        '195': 1593,
        '196': 1593,
        '197': 1593,
        '198': 2048,
        '199': 1479,
        '200': 1251,
        '201': 1251,
        '202': 1251,
        '203': 1251,
        '204': 797,
        '205': 797,
        '206': 797,
        '207': 797,
        '208': 1706,
        '209': 1706,
        '210': 1706,
        '211': 1706,
        '212': 1706,
        '213': 1706,
        '214': 1706,
        '215': 1241,
        '216': 1706,
        '217': 1593,
        '218': 1593,
        '219': 1593,
        '220': 1593,
        '221': 1366,
        '222': 1251,
        '223': 1251,
        '224': 1024,
        '225': 1024,
        '226': 1024,
        '227': 1024,
        '228': 1024,
        '229': 1024,
        '230': 1593,
        '231': 909,
        '232': 1024,
        '233': 1024,
        '234': 1024,
        '235': 1024,
        '236': 682,
        '237': 682,
        '238': 682,
        '239': 682,
        '240': 1139,
        '241': 1251,
        '242': 1139,
        '243': 1139,
        '244': 1139,
        '245': 1139,
        '246': 1139,
        '247': 1124,
        '248': 1139,
        '249': 1251,
        '250': 1251,
        '251': 1251,
        '252': 1251,
        '253': 1139,
        '254': 1251,
        '255': 1139,
        '8211': 1024,
        '8212': 2048,
        '8213': 1536,
        '8215': 1024,
        '8216': 569,
        '8217': 569,
        '8218': 682,
        '8219': 569,
        '8220': 1024,
        '8221': 1024,
        '8222': 1024,
        '8224': 1024,
        '8225': 1024,
        '8226': 1241,
        '8230': 2048,
        '8482': 2044,
      },
    },
  },
  'courier new': {
    regular: {
      upem: 2048,
      avg: 1229,
      isBold: false,
      adv: {
        '32': 1229,
        '33': 1229,
        '34': 1229,
        '35': 1229,
        '36': 1229,
        '37': 1229,
        '38': 1229,
        '39': 1229,
        '40': 1229,
        '41': 1229,
        '42': 1229,
        '43': 1229,
        '44': 1229,
        '45': 1229,
        '46': 1229,
        '47': 1229,
        '48': 1229,
        '49': 1229,
        '50': 1229,
        '51': 1229,
        '52': 1229,
        '53': 1229,
        '54': 1229,
        '55': 1229,
        '56': 1229,
        '57': 1229,
        '58': 1229,
        '59': 1229,
        '60': 1229,
        '61': 1229,
        '62': 1229,
        '63': 1229,
        '64': 1229,
        '65': 1229,
        '66': 1229,
        '67': 1229,
        '68': 1229,
        '69': 1229,
        '70': 1229,
        '71': 1229,
        '72': 1229,
        '73': 1229,
        '74': 1229,
        '75': 1229,
        '76': 1229,
        '77': 1229,
        '78': 1229,
        '79': 1229,
        '80': 1229,
        '81': 1229,
        '82': 1229,
        '83': 1229,
        '84': 1229,
        '85': 1229,
        '86': 1229,
        '87': 1229,
        '88': 1229,
        '89': 1229,
        '90': 1229,
        '91': 1229,
        '92': 1229,
        '93': 1229,
        '94': 1229,
        '95': 1229,
        '96': 1229,
        '97': 1229,
        '98': 1229,
        '99': 1229,
        '100': 1229,
        '101': 1229,
        '102': 1229,
        '103': 1229,
        '104': 1229,
        '105': 1229,
        '106': 1229,
        '107': 1229,
        '108': 1229,
        '109': 1229,
        '110': 1229,
        '111': 1229,
        '112': 1229,
        '113': 1229,
        '114': 1229,
        '115': 1229,
        '116': 1229,
        '117': 1229,
        '118': 1229,
        '119': 1229,
        '120': 1229,
        '121': 1229,
        '122': 1229,
        '123': 1229,
        '124': 1229,
        '125': 1229,
        '126': 1229,
        '160': 1229,
        '161': 1229,
        '162': 1229,
        '163': 1229,
        '164': 1229,
        '165': 1229,
        '166': 1229,
        '167': 1229,
        '168': 1229,
        '169': 1229,
        '170': 1229,
        '171': 1229,
        '172': 1229,
        '173': 1229,
        '174': 1229,
        '175': 1229,
        '176': 1229,
        '177': 1229,
        '178': 1229,
        '179': 1229,
        '180': 1229,
        '181': 1229,
        '182': 1229,
        '183': 1229,
        '184': 1229,
        '185': 1229,
        '186': 1229,
        '187': 1229,
        '188': 1229,
        '189': 1229,
        '190': 1229,
        '191': 1229,
        '192': 1229,
        '193': 1229,
        '194': 1229,
        '195': 1229,
        '196': 1229,
        '197': 1229,
        '198': 1229,
        '199': 1229,
        '200': 1229,
        '201': 1229,
        '202': 1229,
        '203': 1229,
        '204': 1229,
        '205': 1229,
        '206': 1229,
        '207': 1229,
        '208': 1229,
        '209': 1229,
        '210': 1229,
        '211': 1229,
        '212': 1229,
        '213': 1229,
        '214': 1229,
        '215': 1229,
        '216': 1229,
        '217': 1229,
        '218': 1229,
        '219': 1229,
        '220': 1229,
        '221': 1229,
        '222': 1229,
        '223': 1229,
        '224': 1229,
        '225': 1229,
        '226': 1229,
        '227': 1229,
        '228': 1229,
        '229': 1229,
        '230': 1229,
        '231': 1229,
        '232': 1229,
        '233': 1229,
        '234': 1229,
        '235': 1229,
        '236': 1229,
        '237': 1229,
        '238': 1229,
        '239': 1229,
        '240': 1229,
        '241': 1229,
        '242': 1229,
        '243': 1229,
        '244': 1229,
        '245': 1229,
        '246': 1229,
        '247': 1229,
        '248': 1229,
        '249': 1229,
        '250': 1229,
        '251': 1229,
        '252': 1229,
        '253': 1229,
        '254': 1229,
        '255': 1229,
        '8210': 1229,
        '8211': 1229,
        '8212': 1229,
        '8213': 1229,
        '8215': 1229,
        '8216': 1229,
        '8217': 1229,
        '8218': 1229,
        '8219': 1229,
        '8220': 1229,
        '8221': 1229,
        '8222': 1229,
        '8223': 1229,
        '8224': 1229,
        '8225': 1229,
        '8226': 1229,
        '8230': 1229,
        '8482': 1229,
      },
    },
    bold: {
      upem: 2048,
      avg: 1229,
      isBold: true,
      adv: {
        '32': 1229,
        '33': 1229,
        '34': 1229,
        '35': 1229,
        '36': 1229,
        '37': 1229,
        '38': 1229,
        '39': 1229,
        '40': 1229,
        '41': 1229,
        '42': 1229,
        '43': 1229,
        '44': 1229,
        '45': 1229,
        '46': 1229,
        '47': 1229,
        '48': 1229,
        '49': 1229,
        '50': 1229,
        '51': 1229,
        '52': 1229,
        '53': 1229,
        '54': 1229,
        '55': 1229,
        '56': 1229,
        '57': 1229,
        '58': 1229,
        '59': 1229,
        '60': 1229,
        '61': 1229,
        '62': 1229,
        '63': 1229,
        '64': 1229,
        '65': 1229,
        '66': 1229,
        '67': 1229,
        '68': 1229,
        '69': 1229,
        '70': 1229,
        '71': 1229,
        '72': 1229,
        '73': 1229,
        '74': 1229,
        '75': 1229,
        '76': 1229,
        '77': 1229,
        '78': 1229,
        '79': 1229,
        '80': 1229,
        '81': 1229,
        '82': 1229,
        '83': 1229,
        '84': 1229,
        '85': 1229,
        '86': 1229,
        '87': 1229,
        '88': 1229,
        '89': 1229,
        '90': 1229,
        '91': 1229,
        '92': 1229,
        '93': 1229,
        '94': 1229,
        '95': 1229,
        '96': 1229,
        '97': 1229,
        '98': 1229,
        '99': 1229,
        '100': 1229,
        '101': 1229,
        '102': 1229,
        '103': 1229,
        '104': 1229,
        '105': 1229,
        '106': 1229,
        '107': 1229,
        '108': 1229,
        '109': 1229,
        '110': 1229,
        '111': 1229,
        '112': 1229,
        '113': 1229,
        '114': 1229,
        '115': 1229,
        '116': 1229,
        '117': 1229,
        '118': 1229,
        '119': 1229,
        '120': 1229,
        '121': 1229,
        '122': 1229,
        '123': 1229,
        '124': 1229,
        '125': 1229,
        '126': 1229,
        '160': 1229,
        '161': 1229,
        '162': 1229,
        '163': 1229,
        '164': 1229,
        '165': 1229,
        '166': 1229,
        '167': 1229,
        '168': 1229,
        '169': 1229,
        '170': 1229,
        '171': 1229,
        '172': 1229,
        '173': 1229,
        '174': 1229,
        '175': 1229,
        '176': 1229,
        '177': 1229,
        '178': 1229,
        '179': 1229,
        '180': 1229,
        '181': 1229,
        '182': 1229,
        '183': 1229,
        '184': 1229,
        '185': 1229,
        '186': 1229,
        '187': 1229,
        '188': 1229,
        '189': 1229,
        '190': 1229,
        '191': 1229,
        '192': 1229,
        '193': 1229,
        '194': 1229,
        '195': 1229,
        '196': 1229,
        '197': 1229,
        '198': 1229,
        '199': 1229,
        '200': 1229,
        '201': 1229,
        '202': 1229,
        '203': 1229,
        '204': 1229,
        '205': 1229,
        '206': 1229,
        '207': 1229,
        '208': 1229,
        '209': 1229,
        '210': 1229,
        '211': 1229,
        '212': 1229,
        '213': 1229,
        '214': 1229,
        '215': 1229,
        '216': 1229,
        '217': 1229,
        '218': 1229,
        '219': 1229,
        '220': 1229,
        '221': 1229,
        '222': 1229,
        '223': 1229,
        '224': 1229,
        '225': 1229,
        '226': 1229,
        '227': 1229,
        '228': 1229,
        '229': 1229,
        '230': 1229,
        '231': 1229,
        '232': 1229,
        '233': 1229,
        '234': 1229,
        '235': 1229,
        '236': 1229,
        '237': 1229,
        '238': 1229,
        '239': 1229,
        '240': 1229,
        '241': 1229,
        '242': 1229,
        '243': 1229,
        '244': 1229,
        '245': 1229,
        '246': 1229,
        '247': 1229,
        '248': 1229,
        '249': 1229,
        '250': 1229,
        '251': 1229,
        '252': 1229,
        '253': 1229,
        '254': 1229,
        '255': 1229,
        '8210': 1229,
        '8211': 1229,
        '8212': 1229,
        '8213': 1229,
        '8215': 1229,
        '8216': 1229,
        '8217': 1229,
        '8218': 1229,
        '8219': 1229,
        '8220': 1229,
        '8221': 1229,
        '8222': 1229,
        '8223': 1229,
        '8224': 1229,
        '8225': 1229,
        '8226': 1229,
        '8230': 1229,
        '8482': 1229,
      },
    },
  },
  'segoe ui': {
    regular: {
      upem: 2048,
      avg: 1103,
      isBold: false,
      adv: {
        '32': 561,
        '33': 582,
        '34': 803,
        '35': 1210,
        '36': 1104,
        '37': 1676,
        '38': 1639,
        '39': 471,
        '40': 618,
        '41': 618,
        '42': 854,
        '43': 1401,
        '44': 444,
        '45': 819,
        '46': 444,
        '47': 798,
        '48': 1104,
        '49': 1104,
        '50': 1104,
        '51': 1104,
        '52': 1104,
        '53': 1104,
        '54': 1104,
        '55': 1104,
        '56': 1104,
        '57': 1104,
        '58': 444,
        '59': 444,
        '60': 1401,
        '61': 1401,
        '62': 1401,
        '63': 918,
        '64': 1956,
        '65': 1321,
        '66': 1174,
        '67': 1268,
        '68': 1436,
        '69': 1036,
        '70': 1000,
        '71': 1405,
        '72': 1454,
        '73': 545,
        '74': 731,
        '75': 1188,
        '76': 964,
        '77': 1839,
        '78': 1532,
        '79': 1544,
        '80': 1147,
        '81': 1544,
        '82': 1225,
        '83': 1088,
        '84': 1073,
        '85': 1407,
        '86': 1272,
        '87': 1913,
        '88': 1208,
        '89': 1132,
        '90': 1168,
        '91': 618,
        '92': 776,
        '93': 618,
        '94': 1401,
        '95': 850,
        '96': 549,
        '97': 1042,
        '98': 1204,
        '99': 946,
        '100': 1206,
        '101': 1071,
        '102': 641,
        '103': 1206,
        '104': 1159,
        '105': 496,
        '106': 496,
        '107': 1018,
        '108': 496,
        '109': 1764,
        '110': 1159,
        '111': 1200,
        '112': 1204,
        '113': 1206,
        '114': 712,
        '115': 869,
        '116': 694,
        '117': 1159,
        '118': 981,
        '119': 1480,
        '120': 940,
        '121': 991,
        '122': 926,
        '123': 618,
        '124': 490,
        '125': 618,
        '126': 1401,
        '160': 561,
        '161': 582,
        '162': 1104,
        '163': 1104,
        '164': 1138,
        '165': 1104,
        '166': 490,
        '167': 918,
        '168': 848,
        '169': 1823,
        '170': 803,
        '171': 1036,
        '172': 1401,
        '173': 819,
        '174': 1823,
        '175': 850,
        '176': 772,
        '177': 1401,
        '178': 750,
        '179': 750,
        '180': 578,
        '181': 1182,
        '182': 938,
        '183': 444,
        '184': 420,
        '185': 719,
        '186': 882,
        '187': 1036,
        '188': 1856,
        '189': 1906,
        '190': 1950,
        '191': 918,
        '192': 1321,
        '193': 1321,
        '194': 1321,
        '195': 1321,
        '196': 1321,
        '197': 1321,
        '198': 1762,
        '199': 1268,
        '200': 1036,
        '201': 1036,
        '202': 1036,
        '203': 1036,
        '204': 545,
        '205': 545,
        '206': 545,
        '207': 545,
        '208': 1436,
        '209': 1532,
        '210': 1544,
        '211': 1544,
        '212': 1544,
        '213': 1544,
        '214': 1544,
        '215': 1401,
        '216': 1544,
        '217': 1407,
        '218': 1407,
        '219': 1407,
        '220': 1407,
        '221': 1132,
        '222': 1147,
        '223': 1114,
        '224': 1042,
        '225': 1042,
        '226': 1042,
        '227': 1042,
        '228': 1042,
        '229': 1042,
        '230': 1704,
        '231': 946,
        '232': 1071,
        '233': 1071,
        '234': 1071,
        '235': 1071,
        '236': 496,
        '237': 496,
        '238': 496,
        '239': 496,
        '240': 1145,
        '241': 1159,
        '242': 1200,
        '243': 1200,
        '244': 1200,
        '245': 1200,
        '246': 1200,
        '247': 1401,
        '248': 1200,
        '249': 1159,
        '250': 1159,
        '251': 1159,
        '252': 1159,
        '253': 991,
        '254': 1204,
        '255': 991,
        '8208': 819,
        '8209': 819,
        '8210': 1104,
        '8211': 1024,
        '8212': 2048,
        '8213': 2048,
        '8214': 940,
        '8215': 850,
        '8216': 469,
        '8217': 469,
        '8218': 469,
        '8219': 469,
        '8220': 772,
        '8221': 772,
        '8222': 772,
        '8223': 772,
        '8224': 768,
        '8225': 768,
        '8226': 832,
        '8230': 1501,
        '8482': 1583,
      },
    },
    bold: {
      upem: 2048,
      avg: 1208,
      isBold: true,
      adv: {
        '32': 565,
        '33': 670,
        '34': 1010,
        '35': 1213,
        '36': 1178,
        '37': 1776,
        '38': 1740,
        '39': 600,
        '40': 756,
        '41': 756,
        '42': 932,
        '43': 1448,
        '44': 555,
        '45': 828,
        '46': 555,
        '47': 908,
        '48': 1178,
        '49': 1178,
        '50': 1178,
        '51': 1178,
        '52': 1178,
        '53': 1178,
        '54': 1178,
        '55': 1178,
        '56': 1178,
        '57': 1178,
        '58': 555,
        '59': 555,
        '60': 1448,
        '61': 1448,
        '62': 1448,
        '63': 897,
        '64': 1954,
        '65': 1440,
        '66': 1313,
        '67': 1278,
        '68': 1510,
        '69': 1090,
        '70': 1065,
        '71': 1456,
        '72': 1569,
        '73': 649,
        '74': 912,
        '75': 1329,
        '76': 1047,
        '77': 1960,
        '78': 1618,
        '79': 1553,
        '80': 1258,
        '81': 1553,
        '82': 1337,
        '83': 1148,
        '84': 1200,
        '85': 1481,
        '86': 1366,
        '87': 2058,
        '88': 1342,
        '89': 1243,
        '90': 1243,
        '91': 756,
        '92': 893,
        '93': 756,
        '94': 1448,
        '95': 850,
        '96': 643,
        '97': 1102,
        '98': 1270,
        '99': 983,
        '100': 1268,
        '101': 1108,
        '102': 785,
        '103': 1268,
        '104': 1233,
        '105': 582,
        '106': 582,
        '107': 1145,
        '108': 582,
        '109': 1876,
        '110': 1239,
        '111': 1252,
        '112': 1270,
        '113': 1268,
        '114': 815,
        '115': 901,
        '116': 797,
        '117': 1239,
        '118': 1110,
        '119': 1633,
        '120': 1131,
        '121': 1102,
        '122': 981,
        '123': 756,
        '124': 668,
        '125': 756,
        '126': 1448,
        '160': 565,
        '161': 670,
        '162': 1178,
        '163': 1178,
        '164': 1139,
        '165': 1178,
        '166': 668,
        '167': 994,
        '168': 946,
        '169': 1790,
        '170': 840,
        '171': 1190,
        '172': 1448,
        '173': 828,
        '174': 1790,
        '175': 850,
        '176': 778,
        '177': 1448,
        '178': 828,
        '179': 828,
        '180': 621,
        '181': 1255,
        '182': 1043,
        '183': 555,
        '184': 441,
        '185': 807,
        '186': 934,
        '187': 1190,
        '188': 1950,
        '189': 1977,
        '190': 2005,
        '191': 897,
        '192': 1440,
        '193': 1440,
        '194': 1440,
        '195': 1440,
        '196': 1440,
        '197': 1440,
        '198': 1915,
        '199': 1278,
        '200': 1090,
        '201': 1090,
        '202': 1090,
        '203': 1090,
        '204': 649,
        '205': 649,
        '206': 649,
        '207': 649,
        '208': 1510,
        '209': 1618,
        '210': 1552,
        '211': 1552,
        '212': 1552,
        '213': 1552,
        '214': 1552,
        '215': 1448,
        '216': 1553,
        '217': 1481,
        '218': 1481,
        '219': 1481,
        '220': 1481,
        '221': 1243,
        '222': 1258,
        '223': 1286,
        '224': 1102,
        '225': 1102,
        '226': 1102,
        '227': 1102,
        '228': 1102,
        '229': 1102,
        '230': 1696,
        '231': 983,
        '232': 1108,
        '233': 1108,
        '234': 1108,
        '235': 1108,
        '236': 582,
        '237': 582,
        '238': 582,
        '239': 582,
        '240': 1215,
        '241': 1239,
        '242': 1251,
        '243': 1251,
        '244': 1251,
        '245': 1251,
        '246': 1251,
        '247': 1448,
        '248': 1252,
        '249': 1239,
        '250': 1239,
        '251': 1239,
        '252': 1239,
        '253': 1102,
        '254': 1270,
        '255': 1102,
        '8208': 828,
        '8209': 828,
        '8210': 1178,
        '8211': 1024,
        '8212': 2048,
        '8213': 2048,
        '8214': 1220,
        '8215': 850,
        '8216': 594,
        '8217': 594,
        '8218': 594,
        '8219': 594,
        '8220': 1010,
        '8221': 1010,
        '8222': 1010,
        '8223': 1010,
        '8224': 832,
        '8225': 832,
        '8226': 865,
        '8230': 1868,
        '8482': 1579,
      },
    },
  },
};
